// This file is auto-generated by @hey-api/openapi-ts

import {
  type InfiniteData,
  infiniteQueryOptions,
  queryOptions,
  type UseMutationOptions,
} from '@tanstack/react-query';
import type { AxiosError } from 'axios';

import { client } from '../client.gen';
import {
  acceptInvitation,
  addAccountType,
  addApplicationComment,
  applyAndStartInstant,
  approveMcpAuthRequest,
  archiveApplicationApplicationsArchivePost,
  assessRecordings,
  assessRecordingsAdvanced,
  assessSession,
  bulkDeleteByFilter,
  cancelEvalExperiment,
  cancelInterview,
  cancelInterviewPublic,
  chatFollowup,
  checkCamera,
  checkDomainPublicPublicCompaniesDomainCheckPublicIdGet,
  checkEmailExists,
  checkProvidersHealthHealthProvidersGet,
  createCandidateApplicationPublicPublicSessionsCandidateApplicationPost,
  createDemoVideo,
  createEvalExperiment,
  createEvalFixture,
  createEvalReplay,
  createEvaluator,
  createSessionGroup,
  createStage,
  createTemplateTemplatesPost,
  createTestSessionsTestSessionPost,
  createUserWithCompany,
  declineInvitation,
  deleteApplicationsApplicationsDeleteApplicationsDelete,
  deleteKnowledgeItem,
  deleteMemberMembersUserIdDelete,
  deleteRecordingRecordingsRecordingRoomIdDelete,
  deleteSessionGroup,
  deleteStage,
  deleteTemplateTemplatesTemplateIdDelete,
  denyMcpAuthRequest,
  describeImageTaskPublicKnowledgeDescribeImagePost,
  disableTemplateSharingTemplatesTemplateIdShareDelete,
  enableTemplateSharingTemplatesTemplateIdSharePost,
  enrollInSessionGroup,
  evaluateAllEvalRuns,
  evaluateEvalExperiment,
  evaluateEvalRun,
  exportRoomSummaryCsv,
  exportRoomSummaryPdf,
  extractListeningTaskPublicKnowledgeExtractListeningPost,
  extractMaterialTaskPublicKnowledgeExtractMaterialPost,
  fetchYoutubeTaskPublicKnowledgeFetchYoutubePost,
  forkReviewSession,
  generateApiKeyEndpointUsersGenerateKeyPost,
  generateBulkSummariesRoomsGenerateSummaryPost,
  generateKnowledgeImages,
  generateLearningPath,
  generateLearningPathChat,
  generateSessionByTemplatePublicGenerateSessionByTemplatePost,
  generateSessionTemplateAiGenerationSessionTemplatePost,
  generateSingleSummaryLivekitGenerateSingleSummaryPost,
  generateUserLearningPath,
  getAllAssessmentComponents,
  getApplicationComments,
  getAuditLogsGdprAuditLogsGet,
  getAvailabilityPublicPublicSessionsAvailabilityGet,
  getAvailableLlmModels,
  getCandidateFeedback,
  getCandidateLearnRecommendations,
  getCandidatePublicPublicCandidatesApplicationIdGet,
  getCandidatesCount,
  getCandidatesPublicPublicCandidatesGet,
  getCandidatesRoomsCandidatesGet,
  getCompanyCompaniesSingleGet,
  getCompanyInsights,
  getComplianceStatusGdprComplianceStatusGet,
  getConversationTranscriptionPublicPublicRecordingsConversationTranscriptionIdGet,
  getConversationTranscriptionRecordingsConversationTranscriptionIdGet,
  getDefaultAssessmentComponents,
  getDeletionStatusGdprDeletionStatusJobIdGet,
  getDemoVideo,
  getEvalDashboard,
  getEvalExperiment,
  getEvalFixturePrompts,
  getEvalLabelingQueue,
  getEvalLabelQueue,
  getEvalOptions,
  getEvalReplay,
  getEvaluator,
  getEvalWatchToken,
  getExportStatusGdprExportExportIdStatusGet,
  getFeaturedSessionGroups,
  getGdprQueueStatus,
  getGroupVisualizationStatus,
  getHealthGet,
  getKnowledgeByTemplate,
  getKnowledgeHlsManifest,
  getKnowledgeHlsPlaylist,
  getKnowledgeMaterialSignedUrl,
  getLeads,
  getLeadSessionRooms,
  getLeadSessions,
  getLearnCategories,
  getLearningDocument,
  getLearnSessionGroupDetail,
  getLearnSessionGroups,
  getLearnSessions,
  getLibraryBook,
  getMcpAuthRequest,
  getMeetingPublicPublicMeetingPublicIdGet,
  getMemberInvitation,
  getMyEnrollments,
  getMyGamification,
  getMySessionResult,
  getOpenSessionsRoomsOpenSessionsGet,
  getPopularLearnSessions,
  getPublicKnowledgeByTemplate,
  getPublicSessionGroup,
  getPublicTemplate,
  getReviewGeneration,
  getReviewSession,
  getReviewStudioAccess,
  getScheduledSessionPublicPublicSessionsScheduledUrlTokenGet,
  getServerTime,
  getSessionContent,
  getSessionGroup,
  getSessionInfoPublicPublicSessionsRoomIdInfoGet,
  getStages,
  getTemplateSharingStatusTemplatesTemplateIdShareGet,
  getTemplatesTemplatesGet,
  getTemplateTemplatesTemplateIdGet,
  getTemplateTitlesPublicTitlesGet,
  getTtsModelsTtsVoicesModelsGet,
  getTtsProvidersTtsVoicesProvidersGet,
  getTtsVoicesTtsVoicesGet,
  getUserDataSummaryByEmailGdprDataSummaryEmailGet,
  getUserDataSummaryGdprDataSummaryGet,
  getUserUsersAuthGet,
  getVisualizationVideoUrl,
  importCandidatesSessionsTemplateIdImportPost,
  importLearningDocumentUrl,
  importLibraryChapter,
  initBotPublicPublicBotInitPost,
  integrityReview,
  inviteImportedCandidates,
  inviteMemberMembersInvitePost,
  linkSessionToUser,
  listDemoVideos,
  listEvalExperiments,
  listEvalFixtures,
  listEvalReplays,
  listEvalRunLines,
  listEvalRuns,
  listEvaluators,
  listGenerationGallery,
  listLibraryBooks,
  listMcpConnections,
  listMembersMembersGet,
  listReviewGenerations,
  listSessionGroups,
  listVerticalPacks,
  makeCallLivekitMakeCallPost,
  onboardingCompleted,
  type Options,
  orderSessionGroupTemplates,
  practiceEnsureCourse,
  practiceExplainLine,
  practiceGetCourse,
  practiceGetHistory,
  practiceGetLeaderboard,
  practiceGetReview,
  practiceGetStats,
  practiceGetTranscript,
  practiceGetWordStatuses,
  practiceGlossLine,
  practiceListenBeat,
  practiceListWords,
  practiceRecordWordEvents,
  practiceSetWordStatus,
  practiceSpeakCheck,
  practiceStreamWordAudio,
  practiceSynthesizeWord,
  practiceTranslateLine,
  practiceTranslateLines,
  practiceUpsertWatch,
  previewVerticalPacks,
  publishSessionGroup,
  publishTemplateTemplatesTemplateIdPublishPut,
  queueReviewVideoRetry,
  recordIntegrityEvents,
  renameStage,
  requestAccountDeletionGdprDeleteAccountPost,
  requestAccountDeletionPublicGdprDeleteAccountPublicPost,
  requestCallApplicationsRequestCallPost,
  requestDataExportGdprExportPost,
  requestDataExportPublicGdprExportPublicPost,
  requestLeavePublicRequestLeavePost,
  retryReviewGenerationArtifact,
  revokeInvitationMembersRevokePost,
  revokeMcpConnection,
  scheduleInterviewPublicScheduleInterviewPost,
  searchReviewSessions,
  sendFeedbackUsersFeedbackPost,
  sendPasswordReset,
  sendRatingUsersRatingPost,
  sendVerificationEmail,
  setEvalBaseline,
  setEvaluatorVersion,
  signedRecordingPublicPublicRecordingsSignedRecordingRoomIdGet,
  signedRecordingRecordingsSignedRecordingRoomIdGet,
  toggleLearningPathVisibility,
  trackUnlock,
  transcodeYoutubeTaskPublicKnowledgeTranscodeYoutubePost,
  transcribeYoutubeTaskPublicKnowledgeTranscribeYoutubePost,
  triggerDeletionProcessing,
  triggerExportProcessing,
  triggerRetentionCleanup,
  unpublishSessionGroup,
  updateApplicationStageApplicationsUpdateStagePost,
  updateCompanyCompaniesUpdatePut,
  updateEvalFixture,
  updateEvaluator,
  updateRoleMembersRolePost,
  updateSessionGroup,
  updateTemplateTemplatesTemplateIdPut,
  uploadImageKnowledge,
  uploadLearningDocument,
  uploadLearningPathCoverImage,
  uploadListeningKnowledge,
  uploadMp4Knowledge,
  uploadPdfKnowledge,
  uploadYoutubeKnowledge,
  upsertReviewGenerationReview,
  upsertReviewSessionAnnotation,
  validateFieldPublicPublicUsersIsValidFieldGet,
  webLivekitWebhookPost,
} from '../sdk.gen';
import type {
  AcceptInvitationData,
  AcceptInvitationError,
  AddAccountTypeData,
  AddAccountTypeError,
  AddAccountTypeResponse,
  AddApplicationCommentData,
  AddApplicationCommentError,
  AddApplicationCommentResponse,
  ApplyAndStartInstantData,
  ApplyAndStartInstantError,
  ApplyAndStartInstantResponse2,
  ApproveMcpAuthRequestData,
  ApproveMcpAuthRequestError,
  ApproveMcpAuthRequestResponse,
  ArchiveApplicationApplicationsArchivePostData,
  ArchiveApplicationApplicationsArchivePostError,
  AssessRecordingsAdvancedData,
  AssessRecordingsAdvancedError,
  AssessRecordingsData,
  AssessRecordingsError,
  AssessSessionData,
  AssessSessionError,
  AssessSessionResponse,
  BulkDeleteByFilterData,
  BulkDeleteByFilterError,
  CancelEvalExperimentData,
  CancelEvalExperimentError,
  CancelEvalExperimentResponse,
  CancelInterviewData,
  CancelInterviewError,
  CancelInterviewPublicData,
  CancelInterviewPublicError,
  CancelInterviewPublicResponse,
  CancelInterviewResponse2,
  ChatFollowupData,
  ChatFollowupError,
  CheckCameraData,
  CheckCameraError,
  CheckDomainPublicPublicCompaniesDomainCheckPublicIdGetData,
  CheckEmailExistsData,
  CheckProvidersHealthHealthProvidersGetData,
  CreateCandidateApplicationPublicPublicSessionsCandidateApplicationPostData,
  CreateCandidateApplicationPublicPublicSessionsCandidateApplicationPostError,
  CreateCandidateApplicationPublicPublicSessionsCandidateApplicationPostResponse,
  CreateDemoVideoData,
  CreateDemoVideoError,
  CreateDemoVideoResponse,
  CreateEvalExperimentData,
  CreateEvalExperimentError,
  CreateEvalExperimentResponse,
  CreateEvalFixtureData,
  CreateEvalFixtureError,
  CreateEvalFixtureResponse,
  CreateEvalReplayData,
  CreateEvalReplayError,
  CreateEvalReplayResponse,
  CreateEvaluatorData,
  CreateEvaluatorError,
  CreateEvaluatorResponse,
  CreateSessionGroupData,
  CreateSessionGroupError,
  CreateSessionGroupResponse,
  CreateStageData,
  CreateStageError,
  CreateStageResponse,
  CreateTemplateTemplatesPostData,
  CreateTemplateTemplatesPostError,
  CreateTemplateTemplatesPostResponse,
  CreateTestSessionsTestSessionPostData,
  CreateTestSessionsTestSessionPostError,
  CreateTestSessionsTestSessionPostResponse,
  CreateUserWithCompanyData,
  CreateUserWithCompanyError,
  CreateUserWithCompanyResponse,
  DeclineInvitationData,
  DeclineInvitationError,
  DeleteApplicationsApplicationsDeleteApplicationsDeleteData,
  DeleteApplicationsApplicationsDeleteApplicationsDeleteError,
  DeleteKnowledgeItemData,
  DeleteKnowledgeItemError,
  DeleteKnowledgeItemResponse,
  DeleteMemberMembersUserIdDeleteData,
  DeleteMemberMembersUserIdDeleteError,
  DeleteRecordingRecordingsRecordingRoomIdDeleteData,
  DeleteRecordingRecordingsRecordingRoomIdDeleteError,
  DeleteSessionGroupData,
  DeleteSessionGroupError,
  DeleteStageData,
  DeleteStageError,
  DeleteTemplateTemplatesTemplateIdDeleteData,
  DeleteTemplateTemplatesTemplateIdDeleteError,
  DenyMcpAuthRequestData,
  DenyMcpAuthRequestError,
  DenyMcpAuthRequestResponse,
  DescribeImageTaskPublicKnowledgeDescribeImagePostData,
  DescribeImageTaskPublicKnowledgeDescribeImagePostError,
  DisableTemplateSharingTemplatesTemplateIdShareDeleteData,
  DisableTemplateSharingTemplatesTemplateIdShareDeleteError,
  EnableTemplateSharingTemplatesTemplateIdSharePostData,
  EnableTemplateSharingTemplatesTemplateIdSharePostError,
  EnrollInSessionGroupData,
  EnrollInSessionGroupError,
  EvaluateAllEvalRunsData,
  EvaluateAllEvalRunsError,
  EvaluateAllEvalRunsResponse,
  EvaluateEvalExperimentData,
  EvaluateEvalExperimentError,
  EvaluateEvalExperimentResponse,
  EvaluateEvalRunData,
  EvaluateEvalRunError,
  EvaluateEvalRunResponse,
  ExportRoomSummaryCsvData,
  ExportRoomSummaryCsvError,
  ExportRoomSummaryPdfData,
  ExportRoomSummaryPdfError,
  ExportRoomSummaryPdfResponse,
  ExtractListeningTaskPublicKnowledgeExtractListeningPostData,
  ExtractListeningTaskPublicKnowledgeExtractListeningPostError,
  ExtractMaterialTaskPublicKnowledgeExtractMaterialPostData,
  ExtractMaterialTaskPublicKnowledgeExtractMaterialPostError,
  FetchYoutubeTaskPublicKnowledgeFetchYoutubePostData,
  FetchYoutubeTaskPublicKnowledgeFetchYoutubePostError,
  ForkReviewSessionData,
  ForkReviewSessionError,
  ForkReviewSessionResponse2,
  GenerateApiKeyEndpointUsersGenerateKeyPostData,
  GenerateApiKeyEndpointUsersGenerateKeyPostError,
  GenerateApiKeyEndpointUsersGenerateKeyPostResponse,
  GenerateBulkSummariesRoomsGenerateSummaryPostData,
  GenerateBulkSummariesRoomsGenerateSummaryPostError,
  GenerateBulkSummariesRoomsGenerateSummaryPostResponse,
  GenerateKnowledgeImagesData,
  GenerateKnowledgeImagesError,
  GenerateKnowledgeImagesResponse,
  GenerateLearningPathChatData,
  GenerateLearningPathChatError,
  GenerateLearningPathData,
  GenerateLearningPathError,
  GenerateSessionByTemplatePublicGenerateSessionByTemplatePostData,
  GenerateSessionByTemplatePublicGenerateSessionByTemplatePostError,
  GenerateSessionTemplateAiGenerationSessionTemplatePostData,
  GenerateSessionTemplateAiGenerationSessionTemplatePostError,
  GenerateSessionTemplateAiGenerationSessionTemplatePostResponse,
  GenerateSingleSummaryLivekitGenerateSingleSummaryPostData,
  GenerateSingleSummaryLivekitGenerateSingleSummaryPostError,
  GenerateUserLearningPathData,
  GenerateUserLearningPathError,
  GenerateUserLearningPathResponse2,
  GetAllAssessmentComponentsData,
  GetApplicationCommentsData,
  GetAuditLogsGdprAuditLogsGetData,
  GetAvailabilityPublicPublicSessionsAvailabilityGetData,
  GetAvailableLlmModelsData,
  GetCandidateFeedbackData,
  GetCandidateFeedbackError,
  GetCandidateFeedbackResponse,
  GetCandidateLearnRecommendationsData,
  GetCandidatePublicPublicCandidatesApplicationIdGetData,
  GetCandidatesCountData,
  GetCandidatesPublicPublicCandidatesGetData,
  GetCandidatesPublicPublicCandidatesGetError,
  GetCandidatesPublicPublicCandidatesGetResponse,
  GetCandidatesRoomsCandidatesGetData,
  GetCandidatesRoomsCandidatesGetError,
  GetCandidatesRoomsCandidatesGetResponse,
  GetCompanyCompaniesSingleGetData,
  GetCompanyInsightsData,
  GetComplianceStatusGdprComplianceStatusGetData,
  GetConversationTranscriptionPublicPublicRecordingsConversationTranscriptionIdGetData,
  GetConversationTranscriptionRecordingsConversationTranscriptionIdGetData,
  GetDefaultAssessmentComponentsData,
  GetDeletionStatusGdprDeletionStatusJobIdGetData,
  GetDemoVideoData,
  GetEvalDashboardData,
  GetEvalExperimentData,
  GetEvalFixturePromptsData,
  GetEvalLabelingQueueData,
  GetEvalLabelQueueData,
  GetEvalOptionsData,
  GetEvalReplayData,
  GetEvaluatorData,
  GetEvalWatchTokenData,
  GetExportStatusGdprExportExportIdStatusGetData,
  GetFeaturedSessionGroupsData,
  GetGdprQueueStatusData,
  GetGroupVisualizationStatusData,
  GetHealthGetData,
  GetKnowledgeByTemplateData,
  GetKnowledgeHlsManifestData,
  GetKnowledgeHlsPlaylistData,
  GetKnowledgeMaterialSignedUrlData,
  GetLeadsData,
  GetLeadsError,
  GetLeadSessionRoomsData,
  GetLeadSessionsData,
  GetLeadsResponse,
  GetLearnCategoriesData,
  GetLearningDocumentData,
  GetLearnSessionGroupDetailData,
  GetLearnSessionGroupsData,
  GetLearnSessionsData,
  GetLearnSessionsError,
  GetLearnSessionsResponse,
  GetLibraryBookData,
  GetMcpAuthRequestData,
  GetMeetingPublicPublicMeetingPublicIdGetData,
  GetMemberInvitationData,
  GetMyEnrollmentsData,
  GetMyGamificationData,
  GetMySessionResultData,
  GetOpenSessionsRoomsOpenSessionsGetData,
  GetPopularLearnSessionsData,
  GetPublicKnowledgeByTemplateData,
  GetPublicSessionGroupData,
  GetPublicTemplateData,
  GetReviewGenerationData,
  GetReviewSessionData,
  GetReviewStudioAccessData,
  GetScheduledSessionPublicPublicSessionsScheduledUrlTokenGetData,
  GetServerTimeData,
  GetSessionContentData,
  GetSessionGroupData,
  GetSessionInfoPublicPublicSessionsRoomIdInfoGetData,
  GetStagesData,
  GetTemplateSharingStatusTemplatesTemplateIdShareGetData,
  GetTemplatesTemplatesGetData,
  GetTemplateTemplatesTemplateIdGetData,
  GetTemplateTitlesPublicTitlesGetData,
  GetTtsModelsTtsVoicesModelsGetData,
  GetTtsProvidersTtsVoicesProvidersGetData,
  GetTtsVoicesTtsVoicesGetData,
  GetUserDataSummaryByEmailGdprDataSummaryEmailGetData,
  GetUserDataSummaryGdprDataSummaryGetData,
  GetUserUsersAuthGetData,
  GetVisualizationVideoUrlData,
  ImportCandidatesSessionsTemplateIdImportPostData,
  ImportCandidatesSessionsTemplateIdImportPostError,
  ImportLearningDocumentUrlData,
  ImportLearningDocumentUrlError,
  ImportLearningDocumentUrlResponse,
  ImportLibraryChapterData,
  ImportLibraryChapterError,
  ImportLibraryChapterResponse,
  InitBotPublicPublicBotInitPostData,
  InitBotPublicPublicBotInitPostError,
  InitBotPublicPublicBotInitPostResponse,
  IntegrityReviewData,
  IntegrityReviewError,
  InviteImportedCandidatesData,
  InviteImportedCandidatesError,
  InviteImportedCandidatesResponse,
  InviteMemberMembersInvitePostData,
  InviteMemberMembersInvitePostError,
  InviteMemberMembersInvitePostResponse,
  LinkSessionToUserData,
  LinkSessionToUserError,
  ListDemoVideosData,
  ListEvalExperimentsData,
  ListEvalFixturesData,
  ListEvalReplaysData,
  ListEvalRunLinesData,
  ListEvalRunsData,
  ListEvalRunsError,
  ListEvalRunsResponse,
  ListEvaluatorsData,
  ListGenerationGalleryData,
  ListLibraryBooksData,
  ListMcpConnectionsData,
  ListMembersMembersGetData,
  ListReviewGenerationsData,
  ListReviewGenerationsError,
  ListReviewGenerationsResponse,
  ListSessionGroupsData,
  ListVerticalPacksData,
  MakeCallLivekitMakeCallPostData,
  MakeCallLivekitMakeCallPostError,
  OnboardingCompletedData,
  OnboardingCompletedError,
  OnboardingCompletedResponse,
  OrderSessionGroupTemplatesData,
  OrderSessionGroupTemplatesError,
  PracticeEnsureCourseData,
  PracticeEnsureCourseError,
  PracticeEnsureCourseResponse,
  PracticeExplainLineData,
  PracticeExplainLineError,
  PracticeGetCourseData,
  PracticeGetHistoryData,
  PracticeGetLeaderboardData,
  PracticeGetReviewData,
  PracticeGetStatsData,
  PracticeGetTranscriptData,
  PracticeGetWordStatusesData,
  PracticeGlossLineData,
  PracticeGlossLineError,
  PracticeGlossLineResponse,
  PracticeListenBeatData,
  PracticeListenBeatError,
  PracticeListenBeatResponse2,
  PracticeListWordsData,
  PracticeListWordsError,
  PracticeListWordsResponse,
  PracticeRecordWordEventsData,
  PracticeRecordWordEventsError,
  PracticeRecordWordEventsResponse,
  PracticeSetWordStatusData,
  PracticeSetWordStatusError,
  PracticeSetWordStatusResponse,
  PracticeSpeakCheckData,
  PracticeSpeakCheckError,
  PracticeSpeakCheckResponse2,
  PracticeStreamWordAudioData,
  PracticeSynthesizeWordData,
  PracticeSynthesizeWordError,
  PracticeSynthesizeWordResponse,
  PracticeTranslateLineData,
  PracticeTranslateLineError,
  PracticeTranslateLineResponse2,
  PracticeTranslateLinesData,
  PracticeTranslateLinesError,
  PracticeTranslateLinesResponse2,
  PracticeUpsertWatchData,
  PracticeUpsertWatchError,
  PracticeUpsertWatchResponse,
  PreviewVerticalPacksData,
  PreviewVerticalPacksError,
  PreviewVerticalPacksResponse,
  PublishSessionGroupData,
  PublishSessionGroupError,
  PublishTemplateTemplatesTemplateIdPublishPutData,
  PublishTemplateTemplatesTemplateIdPublishPutError,
  QueueReviewVideoRetryData,
  QueueReviewVideoRetryError,
  QueueReviewVideoRetryResponse,
  RecordIntegrityEventsData,
  RecordIntegrityEventsError,
  RenameStageData,
  RenameStageError,
  RenameStageResponse,
  RequestAccountDeletionGdprDeleteAccountPostData,
  RequestAccountDeletionGdprDeleteAccountPostError,
  RequestAccountDeletionGdprDeleteAccountPostResponse,
  RequestAccountDeletionPublicGdprDeleteAccountPublicPostData,
  RequestAccountDeletionPublicGdprDeleteAccountPublicPostError,
  RequestAccountDeletionPublicGdprDeleteAccountPublicPostResponse,
  RequestCallApplicationsRequestCallPostData,
  RequestCallApplicationsRequestCallPostError,
  RequestDataExportGdprExportPostData,
  RequestDataExportGdprExportPostError,
  RequestDataExportGdprExportPostResponse,
  RequestDataExportPublicGdprExportPublicPostData,
  RequestDataExportPublicGdprExportPublicPostError,
  RequestDataExportPublicGdprExportPublicPostResponse,
  RequestLeavePublicRequestLeavePostData,
  RequestLeavePublicRequestLeavePostError,
  RetryReviewGenerationArtifactData,
  RetryReviewGenerationArtifactError,
  RetryReviewGenerationArtifactResponse,
  RevokeInvitationMembersRevokePostData,
  RevokeInvitationMembersRevokePostError,
  RevokeMcpConnectionData,
  RevokeMcpConnectionError,
  ScheduleInterviewPublicScheduleInterviewPostData,
  ScheduleInterviewPublicScheduleInterviewPostError,
  ScheduleInterviewPublicScheduleInterviewPostResponse,
  SearchReviewSessionsData,
  SearchReviewSessionsError,
  SearchReviewSessionsResponse,
  SendFeedbackUsersFeedbackPostData,
  SendFeedbackUsersFeedbackPostError,
  SendPasswordResetData,
  SendPasswordResetError,
  SendRatingUsersRatingPostData,
  SendRatingUsersRatingPostError,
  SendVerificationEmailData,
  SendVerificationEmailError,
  SetEvalBaselineData,
  SetEvalBaselineError,
  SetEvalBaselineResponse,
  SetEvaluatorVersionData,
  SetEvaluatorVersionError,
  SetEvaluatorVersionResponse,
  SignedRecordingPublicPublicRecordingsSignedRecordingRoomIdGetData,
  SignedRecordingRecordingsSignedRecordingRoomIdGetData,
  ToggleLearningPathVisibilityData,
  ToggleLearningPathVisibilityError,
  TrackUnlockData,
  TrackUnlockError,
  TranscodeYoutubeTaskPublicKnowledgeTranscodeYoutubePostData,
  TranscodeYoutubeTaskPublicKnowledgeTranscodeYoutubePostError,
  TranscribeYoutubeTaskPublicKnowledgeTranscribeYoutubePostData,
  TranscribeYoutubeTaskPublicKnowledgeTranscribeYoutubePostError,
  TriggerDeletionProcessingData,
  TriggerDeletionProcessingError,
  TriggerExportProcessingData,
  TriggerExportProcessingError,
  TriggerRetentionCleanupData,
  TriggerRetentionCleanupError,
  UnpublishSessionGroupData,
  UnpublishSessionGroupError,
  UpdateApplicationStageApplicationsUpdateStagePostData,
  UpdateApplicationStageApplicationsUpdateStagePostError,
  UpdateCompanyCompaniesUpdatePutData,
  UpdateCompanyCompaniesUpdatePutError,
  UpdateEvalFixtureData,
  UpdateEvalFixtureError,
  UpdateEvalFixtureResponse,
  UpdateEvaluatorData,
  UpdateEvaluatorError,
  UpdateEvaluatorResponse,
  UpdateRoleMembersRolePostData,
  UpdateRoleMembersRolePostError,
  UpdateSessionGroupData,
  UpdateSessionGroupError,
  UpdateTemplateTemplatesTemplateIdPutData,
  UpdateTemplateTemplatesTemplateIdPutError,
  UploadImageKnowledgeData,
  UploadImageKnowledgeError,
  UploadImageKnowledgeResponse,
  UploadLearningDocumentData,
  UploadLearningDocumentError,
  UploadLearningDocumentResponse,
  UploadLearningPathCoverImageData,
  UploadLearningPathCoverImageError,
  UploadListeningKnowledgeData,
  UploadListeningKnowledgeError,
  UploadListeningKnowledgeResponse,
  UploadMp4KnowledgeData,
  UploadMp4KnowledgeError,
  UploadMp4KnowledgeResponse,
  UploadPdfKnowledgeData,
  UploadPdfKnowledgeError,
  UploadPdfKnowledgeResponse,
  UploadYoutubeKnowledgeData,
  UploadYoutubeKnowledgeError,
  UploadYoutubeKnowledgeResponse,
  UpsertReviewGenerationReviewData,
  UpsertReviewGenerationReviewError,
  UpsertReviewGenerationReviewResponse,
  UpsertReviewSessionAnnotationData,
  UpsertReviewSessionAnnotationError,
  UpsertReviewSessionAnnotationResponse,
  ValidateFieldPublicPublicUsersIsValidFieldGetData,
  WebLivekitWebhookPostData,
  WebLivekitWebhookPostError,
} from '../types.gen';

export type QueryKey<TOptions extends Options> = [
  Pick<TOptions, 'baseURL' | 'body' | 'headers' | 'path' | 'query'> & {
    _id: string;
    _infinite?: boolean;
    tags?: ReadonlyArray<string>;
  },
];

const createQueryKey = <TOptions extends Options>(
  id: string,
  options?: TOptions,
  infinite?: boolean,
  tags?: ReadonlyArray<string>,
): [QueryKey<TOptions>[0]] => {
  const params: QueryKey<TOptions>[0] = {
    _id: id,
    baseURL:
      options?.baseURL || (options?.client ?? client).getConfig().baseURL,
  } as QueryKey<TOptions>[0];
  if (infinite) {
    params._infinite = infinite;
  }
  if (tags) {
    params.tags = tags;
  }
  if (options?.body) {
    params.body = options.body;
  }
  if (options?.headers) {
    params.headers = options.headers;
  }
  if (options?.path) {
    params.path = options.path;
  }
  if (options?.query) {
    params.query = options.query;
  }
  return [params];
};

export const getHealthGetQueryKey = (options?: Options<GetHealthGetData>) =>
  createQueryKey('getHealthGet', options);

/**
 * Get
 */
export const getHealthGetOptions = (options?: Options<GetHealthGetData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getHealthGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getHealthGetQueryKey(options),
  });
};

export const getServerTimeQueryKey = (options?: Options<GetServerTimeData>) =>
  createQueryKey('getServerTime', options);

/**
 * Get Server Time
 *
 * Returns the current server UTC time for client-side clock sync
 */
export const getServerTimeOptions = (options?: Options<GetServerTimeData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getServerTime({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getServerTimeQueryKey(options),
  });
};

export const getVisualizationVideoUrlQueryKey = (
  options: Options<GetVisualizationVideoUrlData>,
) => createQueryKey('getVisualizationVideoUrl', options);

/**
 * Get Visualization Video Url
 *
 * Return signed video/poster URLs plus segment timings of a video story knowledge item.
 */
export const getVisualizationVideoUrlOptions = (
  options: Options<GetVisualizationVideoUrlData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getVisualizationVideoUrl({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getVisualizationVideoUrlQueryKey(options),
  });
};

export const getMeetingPublicPublicMeetingPublicIdGetQueryKey = (
  options: Options<GetMeetingPublicPublicMeetingPublicIdGetData>,
) => createQueryKey('getMeetingPublicPublicMeetingPublicIdGet', options);

/**
 * Get Meeting Public
 *
 * Public endpoint to get meeting information by public ID
 */
export const getMeetingPublicPublicMeetingPublicIdGetOptions = (
  options: Options<GetMeetingPublicPublicMeetingPublicIdGetData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getMeetingPublicPublicMeetingPublicIdGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getMeetingPublicPublicMeetingPublicIdGetQueryKey(options),
  });
};

export const getPublicTemplateQueryKey = (
  options: Options<GetPublicTemplateData>,
) => createQueryKey('getPublicTemplate', options);

/**
 * Get Public Template
 */
export const getPublicTemplateOptions = (
  options: Options<GetPublicTemplateData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getPublicTemplate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getPublicTemplateQueryKey(options),
  });
};

export const getCandidatePublicPublicCandidatesApplicationIdGetQueryKey = (
  options: Options<GetCandidatePublicPublicCandidatesApplicationIdGetData>,
) =>
  createQueryKey('getCandidatePublicPublicCandidatesApplicationIdGet', options);

/**
 * Get Candidate Public
 *
 * Public endpoint to get a single candidate by application ID
 */
export const getCandidatePublicPublicCandidatesApplicationIdGetOptions = (
  options: Options<GetCandidatePublicPublicCandidatesApplicationIdGetData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getCandidatePublicPublicCandidatesApplicationIdGet(
        {
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        },
      );
      return data;
    },
    queryKey:
      getCandidatePublicPublicCandidatesApplicationIdGetQueryKey(options),
  });
};

export const getCandidateLearnRecommendationsQueryKey = (
  options: Options<GetCandidateLearnRecommendationsData>,
) => createQueryKey('getCandidateLearnRecommendations', options);

/**
 * Get Candidate Learn Recommendations
 *
 * Generate AI-based learning recommendations from a candidate's assessment results.
 */
export const getCandidateLearnRecommendationsOptions = (
  options: Options<GetCandidateLearnRecommendationsData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getCandidateLearnRecommendations({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getCandidateLearnRecommendationsQueryKey(options),
  });
};

export const checkDomainPublicPublicCompaniesDomainCheckPublicIdGetQueryKey = (
  options: Options<CheckDomainPublicPublicCompaniesDomainCheckPublicIdGetData>,
) =>
  createQueryKey(
    'checkDomainPublicPublicCompaniesDomainCheckPublicIdGet',
    options,
  );

/**
 * Check Domain Public
 *
 * Public endpoint to check if domain is available
 */
export const checkDomainPublicPublicCompaniesDomainCheckPublicIdGetOptions = (
  options: Options<CheckDomainPublicPublicCompaniesDomainCheckPublicIdGetData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } =
        await checkDomainPublicPublicCompaniesDomainCheckPublicIdGet({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
      return data;
    },
    queryKey:
      checkDomainPublicPublicCompaniesDomainCheckPublicIdGetQueryKey(options),
  });
};

export const validateFieldPublicPublicUsersIsValidFieldGetQueryKey = (
  options: Options<ValidateFieldPublicPublicUsersIsValidFieldGetData>,
) => createQueryKey('validateFieldPublicPublicUsersIsValidFieldGet', options);

/**
 * Validate Field Public
 *
 * Public endpoint to validate user fields like email
 */
export const validateFieldPublicPublicUsersIsValidFieldGetOptions = (
  options: Options<ValidateFieldPublicPublicUsersIsValidFieldGetData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await validateFieldPublicPublicUsersIsValidFieldGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: validateFieldPublicPublicUsersIsValidFieldGetQueryKey(options),
  });
};

/**
 * Send Password Reset
 */
export const sendPasswordResetMutation = (
  options?: Partial<Options<SendPasswordResetData>>,
): UseMutationOptions<
  unknown,
  AxiosError<SendPasswordResetError>,
  Options<SendPasswordResetData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    AxiosError<SendPasswordResetError>,
    Options<SendPasswordResetData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await sendPasswordReset({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getSessionInfoPublicPublicSessionsRoomIdInfoGetQueryKey = (
  options: Options<GetSessionInfoPublicPublicSessionsRoomIdInfoGetData>,
) => createQueryKey('getSessionInfoPublicPublicSessionsRoomIdInfoGet', options);

/**
 * Get Session Info Public
 *
 * Public endpoint to get session information
 */
export const getSessionInfoPublicPublicSessionsRoomIdInfoGetOptions = (
  options: Options<GetSessionInfoPublicPublicSessionsRoomIdInfoGetData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getSessionInfoPublicPublicSessionsRoomIdInfoGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getSessionInfoPublicPublicSessionsRoomIdInfoGetQueryKey(options),
  });
};

/**
 * Record Integrity Events
 *
 * The session page reports tab switches and copy/paste attempts while the session runs.
 */
export const recordIntegrityEventsMutation = (
  options?: Partial<Options<RecordIntegrityEventsData>>,
): UseMutationOptions<
  unknown,
  AxiosError<RecordIntegrityEventsError>,
  Options<RecordIntegrityEventsData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    AxiosError<RecordIntegrityEventsError>,
    Options<RecordIntegrityEventsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await recordIntegrityEvents({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getSessionContentQueryKey = (
  options: Options<GetSessionContentData>,
) => createQueryKey('getSessionContent', options);

/**
 * Get Session Content Public
 *
 * Public endpoint to get session content (carousel slides, interactive elements) for a room.
 */
export const getSessionContentOptions = (
  options: Options<GetSessionContentData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getSessionContent({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getSessionContentQueryKey(options),
  });
};

export const getScheduledSessionPublicPublicSessionsScheduledUrlTokenGetQueryKey =
  (
    options: Options<GetScheduledSessionPublicPublicSessionsScheduledUrlTokenGetData>,
  ) =>
    createQueryKey(
      'getScheduledSessionPublicPublicSessionsScheduledUrlTokenGet',
      options,
    );

/**
 * Get Scheduled Session Public
 *
 * Public endpoint to get scheduled session invitation details by URL token
 */
export const getScheduledSessionPublicPublicSessionsScheduledUrlTokenGetOptions =
  (
    options: Options<GetScheduledSessionPublicPublicSessionsScheduledUrlTokenGetData>,
  ) => {
    return queryOptions({
      queryFn: async ({ queryKey, signal }) => {
        const { data } =
          await getScheduledSessionPublicPublicSessionsScheduledUrlTokenGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
          });
        return data;
      },
      queryKey:
        getScheduledSessionPublicPublicSessionsScheduledUrlTokenGetQueryKey(
          options,
        ),
    });
  };

export const getAvailabilityPublicPublicSessionsAvailabilityGetQueryKey = (
  options: Options<GetAvailabilityPublicPublicSessionsAvailabilityGetData>,
) =>
  createQueryKey('getAvailabilityPublicPublicSessionsAvailabilityGet', options);

/**
 * Get Availability Public
 *
 * Public endpoint to get available time slots for a given date and duration
 */
export const getAvailabilityPublicPublicSessionsAvailabilityGetOptions = (
  options: Options<GetAvailabilityPublicPublicSessionsAvailabilityGetData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getAvailabilityPublicPublicSessionsAvailabilityGet(
        {
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        },
      );
      return data;
    },
    queryKey:
      getAvailabilityPublicPublicSessionsAvailabilityGetQueryKey(options),
  });
};

/**
 * Init Bot Public
 *
 * Public endpoint to initialize bot
 */
export const initBotPublicPublicBotInitPostMutation = (
  options?: Partial<Options<InitBotPublicPublicBotInitPostData>>,
): UseMutationOptions<
  InitBotPublicPublicBotInitPostResponse,
  AxiosError<InitBotPublicPublicBotInitPostError>,
  Options<InitBotPublicPublicBotInitPostData>
> => {
  const mutationOptions: UseMutationOptions<
    InitBotPublicPublicBotInitPostResponse,
    AxiosError<InitBotPublicPublicBotInitPostError>,
    Options<InitBotPublicPublicBotInitPostData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await initBotPublicPublicBotInitPost({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const signedRecordingPublicPublicRecordingsSignedRecordingRoomIdGetQueryKey =
  (
    options: Options<SignedRecordingPublicPublicRecordingsSignedRecordingRoomIdGetData>,
  ) =>
    createQueryKey(
      'signedRecordingPublicPublicRecordingsSignedRecordingRoomIdGet',
      options,
    );

/**
 * Signed Recording Public
 *
 * Public endpoint to get signed recording URL when template is shared
 */
export const signedRecordingPublicPublicRecordingsSignedRecordingRoomIdGetOptions =
  (
    options: Options<SignedRecordingPublicPublicRecordingsSignedRecordingRoomIdGetData>,
  ) => {
    return queryOptions({
      queryFn: async ({ queryKey, signal }) => {
        const { data } =
          await signedRecordingPublicPublicRecordingsSignedRecordingRoomIdGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
          });
        return data;
      },
      queryKey:
        signedRecordingPublicPublicRecordingsSignedRecordingRoomIdGetQueryKey(
          options,
        ),
    });
  };

export const getConversationTranscriptionPublicPublicRecordingsConversationTranscriptionIdGetQueryKey =
  (
    options: Options<GetConversationTranscriptionPublicPublicRecordingsConversationTranscriptionIdGetData>,
  ) =>
    createQueryKey(
      'getConversationTranscriptionPublicPublicRecordingsConversationTranscriptionIdGet',
      options,
    );

/**
 * Get Conversation Transcription Public
 *
 * Public endpoint to get transcription in conversation format when template is shared
 */
export const getConversationTranscriptionPublicPublicRecordingsConversationTranscriptionIdGetOptions =
  (
    options: Options<GetConversationTranscriptionPublicPublicRecordingsConversationTranscriptionIdGetData>,
  ) => {
    return queryOptions({
      queryFn: async ({ queryKey, signal }) => {
        const { data } =
          await getConversationTranscriptionPublicPublicRecordingsConversationTranscriptionIdGet(
            {
              ...options,
              ...queryKey[0],
              signal,
              throwOnError: true,
            },
          );
        return data;
      },
      queryKey:
        getConversationTranscriptionPublicPublicRecordingsConversationTranscriptionIdGetQueryKey(
          options,
        ),
    });
  };

/**
 * Create Candidate Application Public
 *
 * Public endpoint to create candidate application
 */
export const createCandidateApplicationPublicPublicSessionsCandidateApplicationPostMutation =
  (
    options?: Partial<
      Options<CreateCandidateApplicationPublicPublicSessionsCandidateApplicationPostData>
    >,
  ): UseMutationOptions<
    CreateCandidateApplicationPublicPublicSessionsCandidateApplicationPostResponse,
    AxiosError<CreateCandidateApplicationPublicPublicSessionsCandidateApplicationPostError>,
    Options<CreateCandidateApplicationPublicPublicSessionsCandidateApplicationPostData>
  > => {
    const mutationOptions: UseMutationOptions<
      CreateCandidateApplicationPublicPublicSessionsCandidateApplicationPostResponse,
      AxiosError<CreateCandidateApplicationPublicPublicSessionsCandidateApplicationPostError>,
      Options<CreateCandidateApplicationPublicPublicSessionsCandidateApplicationPostData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } =
          await createCandidateApplicationPublicPublicSessionsCandidateApplicationPost(
            {
              ...options,
              ...fnOptions,
              throwOnError: true,
            },
          );
        return data;
      },
    };
    return mutationOptions;
  };

/**
 * Schedule Interview
 *
 * Schedule an interview for a specific time slot
 */
export const scheduleInterviewPublicScheduleInterviewPostMutation = (
  options?: Partial<Options<ScheduleInterviewPublicScheduleInterviewPostData>>,
): UseMutationOptions<
  ScheduleInterviewPublicScheduleInterviewPostResponse,
  AxiosError<ScheduleInterviewPublicScheduleInterviewPostError>,
  Options<ScheduleInterviewPublicScheduleInterviewPostData>
> => {
  const mutationOptions: UseMutationOptions<
    ScheduleInterviewPublicScheduleInterviewPostResponse,
    AxiosError<ScheduleInterviewPublicScheduleInterviewPostError>,
    Options<ScheduleInterviewPublicScheduleInterviewPostData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await scheduleInterviewPublicScheduleInterviewPost({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Cancel Interview Public
 *
 * The candidate cancels their booked interview from the schedule page (the invite token is the secret).
 */
export const cancelInterviewPublicMutation = (
  options?: Partial<Options<CancelInterviewPublicData>>,
): UseMutationOptions<
  CancelInterviewPublicResponse,
  AxiosError<CancelInterviewPublicError>,
  Options<CancelInterviewPublicData>
> => {
  const mutationOptions: UseMutationOptions<
    CancelInterviewPublicResponse,
    AxiosError<CancelInterviewPublicError>,
    Options<CancelInterviewPublicData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await cancelInterviewPublic({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Apply And Start Instant
 *
 * Create candidate application and immediately start an instant session
 */
export const applyAndStartInstantMutation = (
  options?: Partial<Options<ApplyAndStartInstantData>>,
): UseMutationOptions<
  ApplyAndStartInstantResponse2,
  AxiosError<ApplyAndStartInstantError>,
  Options<ApplyAndStartInstantData>
> => {
  const mutationOptions: UseMutationOptions<
    ApplyAndStartInstantResponse2,
    AxiosError<ApplyAndStartInstantError>,
    Options<ApplyAndStartInstantData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await applyAndStartInstant({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Transcode Youtube Task
 *
 * Cloud Tasks entrypoint. Creates a Transcoder job (if not created yet) and polls status by re-enqueueing itself.
 * Updates knowledge_base_items with HLS manifest/base URL when done.
 */
export const transcodeYoutubeTaskPublicKnowledgeTranscodeYoutubePostMutation = (
  options?: Partial<
    Options<TranscodeYoutubeTaskPublicKnowledgeTranscodeYoutubePostData>
  >,
): UseMutationOptions<
  unknown,
  AxiosError<TranscodeYoutubeTaskPublicKnowledgeTranscodeYoutubePostError>,
  Options<TranscodeYoutubeTaskPublicKnowledgeTranscodeYoutubePostData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    AxiosError<TranscodeYoutubeTaskPublicKnowledgeTranscodeYoutubePostError>,
    Options<TranscodeYoutubeTaskPublicKnowledgeTranscodeYoutubePostData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } =
        await transcodeYoutubeTaskPublicKnowledgeTranscodeYoutubePost({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Fetch Youtube Task
 *
 * Cloud Tasks entrypoint. Downloads the YouTube MP4, uploads it to GCS, then enqueues transcode + transcription.
 *
 * This keeps the authenticated `/knowledge/youtube` endpoint fast.
 */
export const fetchYoutubeTaskPublicKnowledgeFetchYoutubePostMutation = (
  options?: Partial<
    Options<FetchYoutubeTaskPublicKnowledgeFetchYoutubePostData>
  >,
): UseMutationOptions<
  unknown,
  AxiosError<FetchYoutubeTaskPublicKnowledgeFetchYoutubePostError>,
  Options<FetchYoutubeTaskPublicKnowledgeFetchYoutubePostData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    AxiosError<FetchYoutubeTaskPublicKnowledgeFetchYoutubePostError>,
    Options<FetchYoutubeTaskPublicKnowledgeFetchYoutubePostData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await fetchYoutubeTaskPublicKnowledgeFetchYoutubePost({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getKnowledgeHlsManifestQueryKey = (
  options: Options<GetKnowledgeHlsManifestData>,
) => createQueryKey('getKnowledgeHlsManifest', options);

/**
 * Get Knowledge Hls Manifest
 *
 * Pasteable HLS master manifest URL for public apps/players.
 *
 * - The manifest is served from the recorder domain (this endpoint).
 * - Every referenced URI inside the manifest is rewritten to a short-lived GCS signed URL.
 */
export const getKnowledgeHlsManifestOptions = (
  options: Options<GetKnowledgeHlsManifestData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getKnowledgeHlsManifest({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getKnowledgeHlsManifestQueryKey(options),
  });
};

export const getKnowledgeHlsPlaylistQueryKey = (
  options: Options<GetKnowledgeHlsPlaylistData>,
) => createQueryKey('getKnowledgeHlsPlaylist', options);

/**
 * Get Knowledge Hls Playlist
 *
 * Serves an HLS playlist (m3u8) from GCS, rewriting all referenced URIs to signed URLs.
 *
 * This is needed because master manifests often reference variant playlists, and those playlists
 * contain segment URIs that must also be signed when the bucket is private.
 */
export const getKnowledgeHlsPlaylistOptions = (
  options: Options<GetKnowledgeHlsPlaylistData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getKnowledgeHlsPlaylist({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getKnowledgeHlsPlaylistQueryKey(options),
  });
};

export const getKnowledgeMaterialSignedUrlQueryKey = (
  options: Options<GetKnowledgeMaterialSignedUrlData>,
) => createQueryKey('getKnowledgeMaterialSignedUrl', options);

/**
 * Get Knowledge Material Signed Url
 *
 * Returns a short-lived signed URL for a knowledge "material" upload (PDF/PPT/DOC).
 *
 * The bucket is expected to be private; do NOT use stored public GCS URLs for downloads.
 */
export const getKnowledgeMaterialSignedUrlOptions = (
  options: Options<GetKnowledgeMaterialSignedUrlData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getKnowledgeMaterialSignedUrl({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getKnowledgeMaterialSignedUrlQueryKey(options),
  });
};

export const getPublicKnowledgeByTemplateQueryKey = (
  options: Options<GetPublicKnowledgeByTemplateData>,
) => createQueryKey('getPublicKnowledgeByTemplate', options);

/**
 * Get Public Knowledge By Template
 *
 * Public endpoint to list knowledge materials for a session template.
 * Used on the learning path share page.
 */
export const getPublicKnowledgeByTemplateOptions = (
  options: Options<GetPublicKnowledgeByTemplateData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getPublicKnowledgeByTemplate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getPublicKnowledgeByTemplateQueryKey(options),
  });
};

/**
 * Transcribe Youtube Task
 *
 * Cloud Tasks entrypoint. Calls Gemini on the uploaded MP4 (GCS) and stores a timestamped transcription/event list.
 * Creates a separate knowledge_base_item with type=transcription and links it from the video knowledge item.
 */
export const transcribeYoutubeTaskPublicKnowledgeTranscribeYoutubePostMutation =
  (
    options?: Partial<
      Options<TranscribeYoutubeTaskPublicKnowledgeTranscribeYoutubePostData>
    >,
  ): UseMutationOptions<
    unknown,
    AxiosError<TranscribeYoutubeTaskPublicKnowledgeTranscribeYoutubePostError>,
    Options<TranscribeYoutubeTaskPublicKnowledgeTranscribeYoutubePostData>
  > => {
    const mutationOptions: UseMutationOptions<
      unknown,
      AxiosError<TranscribeYoutubeTaskPublicKnowledgeTranscribeYoutubePostError>,
      Options<TranscribeYoutubeTaskPublicKnowledgeTranscribeYoutubePostData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } =
          await transcribeYoutubeTaskPublicKnowledgeTranscribeYoutubePost({
            ...options,
            ...fnOptions,
            throwOnError: true,
          });
        return data;
      },
    };
    return mutationOptions;
  };

/**
 * Extract Material Task
 *
 * Cloud Tasks entrypoint. Calls Gemini on an uploaded material file (PDF/PPT/PPTX/DOC/DOCX)
 * using its GCS URI and stores extracted text into knowledge_base_items.data.content.
 *
 * This text is later passed as full context to the presentation agent.
 */
export const extractMaterialTaskPublicKnowledgeExtractMaterialPostMutation = (
  options?: Partial<
    Options<ExtractMaterialTaskPublicKnowledgeExtractMaterialPostData>
  >,
): UseMutationOptions<
  unknown,
  AxiosError<ExtractMaterialTaskPublicKnowledgeExtractMaterialPostError>,
  Options<ExtractMaterialTaskPublicKnowledgeExtractMaterialPostData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    AxiosError<ExtractMaterialTaskPublicKnowledgeExtractMaterialPostError>,
    Options<ExtractMaterialTaskPublicKnowledgeExtractMaterialPostData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } =
        await extractMaterialTaskPublicKnowledgeExtractMaterialPost({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Extract Listening Task
 *
 * Cloud Tasks entrypoint: read a listening exercise's questions, answers and transcript (api.knowledge.listening).
 */
export const extractListeningTaskPublicKnowledgeExtractListeningPostMutation = (
  options?: Partial<
    Options<ExtractListeningTaskPublicKnowledgeExtractListeningPostData>
  >,
): UseMutationOptions<
  unknown,
  AxiosError<ExtractListeningTaskPublicKnowledgeExtractListeningPostError>,
  Options<ExtractListeningTaskPublicKnowledgeExtractListeningPostData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    AxiosError<ExtractListeningTaskPublicKnowledgeExtractListeningPostError>,
    Options<ExtractListeningTaskPublicKnowledgeExtractListeningPostData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } =
        await extractListeningTaskPublicKnowledgeExtractListeningPost({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Describe Image Task
 *
 * Cloud Tasks entrypoint. Calls Gemini vision on an uploaded image to generate a detailed
 * description, then stores it in knowledge_base_items.data.content and data.description.
 *
 * This description is later included in the agent's system prompt so it knows what each image
 * contains and can intelligently choose which image to show.
 */
export const describeImageTaskPublicKnowledgeDescribeImagePostMutation = (
  options?: Partial<
    Options<DescribeImageTaskPublicKnowledgeDescribeImagePostData>
  >,
): UseMutationOptions<
  unknown,
  AxiosError<DescribeImageTaskPublicKnowledgeDescribeImagePostError>,
  Options<DescribeImageTaskPublicKnowledgeDescribeImagePostData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    AxiosError<DescribeImageTaskPublicKnowledgeDescribeImagePostError>,
    Options<DescribeImageTaskPublicKnowledgeDescribeImagePostData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await describeImageTaskPublicKnowledgeDescribeImagePost({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Request Leave
 */
export const requestLeavePublicRequestLeavePostMutation = (
  options?: Partial<Options<RequestLeavePublicRequestLeavePostData>>,
): UseMutationOptions<
  unknown,
  AxiosError<RequestLeavePublicRequestLeavePostError>,
  Options<RequestLeavePublicRequestLeavePostData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    AxiosError<RequestLeavePublicRequestLeavePostError>,
    Options<RequestLeavePublicRequestLeavePostData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await requestLeavePublicRequestLeavePost({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Generate Session By Template
 */
export const generateSessionByTemplatePublicGenerateSessionByTemplatePostMutation =
  (
    options?: Partial<
      Options<GenerateSessionByTemplatePublicGenerateSessionByTemplatePostData>
    >,
  ): UseMutationOptions<
    unknown,
    AxiosError<GenerateSessionByTemplatePublicGenerateSessionByTemplatePostError>,
    Options<GenerateSessionByTemplatePublicGenerateSessionByTemplatePostData>
  > => {
    const mutationOptions: UseMutationOptions<
      unknown,
      AxiosError<GenerateSessionByTemplatePublicGenerateSessionByTemplatePostError>,
      Options<GenerateSessionByTemplatePublicGenerateSessionByTemplatePostData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } =
          await generateSessionByTemplatePublicGenerateSessionByTemplatePost({
            ...options,
            ...fnOptions,
            throwOnError: true,
          });
        return data;
      },
    };
    return mutationOptions;
  };

export const getCandidatesPublicPublicCandidatesGetQueryKey = (
  options?: Options<GetCandidatesPublicPublicCandidatesGetData>,
) => createQueryKey('getCandidatesPublicPublicCandidatesGet', options);

/**
 * Get Candidates Public
 */
export const getCandidatesPublicPublicCandidatesGetOptions = (
  options?: Options<GetCandidatesPublicPublicCandidatesGetData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getCandidatesPublicPublicCandidatesGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getCandidatesPublicPublicCandidatesGetQueryKey(options),
  });
};

const createInfiniteParams = <
  K extends Pick<QueryKey<Options>[0], 'body' | 'headers' | 'path' | 'query'>,
>(
  queryKey: QueryKey<Options>,
  page: K,
) => {
  const params = {
    ...queryKey[0],
  };
  if (page.body) {
    params.body = {
      ...(queryKey[0].body as any),
      ...(page.body as any),
    };
  }
  if (page.headers) {
    params.headers = {
      ...queryKey[0].headers,
      ...page.headers,
    };
  }
  if (page.path) {
    params.path = {
      ...(queryKey[0].path as any),
      ...(page.path as any),
    };
  }
  if (page.query) {
    params.query = {
      ...(queryKey[0].query as any),
      ...(page.query as any),
    };
  }
  return params as unknown as typeof page;
};

export const getCandidatesPublicPublicCandidatesGetInfiniteQueryKey = (
  options?: Options<GetCandidatesPublicPublicCandidatesGetData>,
): QueryKey<Options<GetCandidatesPublicPublicCandidatesGetData>> =>
  createQueryKey('getCandidatesPublicPublicCandidatesGet', options, true);

/**
 * Get Candidates Public
 */
export const getCandidatesPublicPublicCandidatesGetInfiniteOptions = (
  options?: Options<GetCandidatesPublicPublicCandidatesGetData>,
) => {
  return infiniteQueryOptions<
    GetCandidatesPublicPublicCandidatesGetResponse,
    AxiosError<GetCandidatesPublicPublicCandidatesGetError>,
    InfiniteData<GetCandidatesPublicPublicCandidatesGetResponse>,
    QueryKey<Options<GetCandidatesPublicPublicCandidatesGetData>>,
    | number
    | Pick<
        QueryKey<Options<GetCandidatesPublicPublicCandidatesGetData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetCandidatesPublicPublicCandidatesGetData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getCandidatesPublicPublicCandidatesGet({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getCandidatesPublicPublicCandidatesGetInfiniteQueryKey(options),
    },
  );
};

export const getMemberInvitationQueryKey = (
  options: Options<GetMemberInvitationData>,
) => createQueryKey('getMemberInvitation', options);

/**
 * Get Invitation
 */
export const getMemberInvitationOptions = (
  options: Options<GetMemberInvitationData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getMemberInvitation({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getMemberInvitationQueryKey(options),
  });
};

export const checkEmailExistsQueryKey = (
  options: Options<CheckEmailExistsData>,
) => createQueryKey('checkEmailExists', options);

/**
 * Check Email Exists
 */
export const checkEmailExistsOptions = (
  options: Options<CheckEmailExistsData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await checkEmailExists({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: checkEmailExistsQueryKey(options),
  });
};

/**
 * Create With Company
 */
export const createUserWithCompanyMutation = (
  options?: Partial<Options<CreateUserWithCompanyData>>,
): UseMutationOptions<
  CreateUserWithCompanyResponse,
  AxiosError<CreateUserWithCompanyError>,
  Options<CreateUserWithCompanyData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateUserWithCompanyResponse,
    AxiosError<CreateUserWithCompanyError>,
    Options<CreateUserWithCompanyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createUserWithCompany({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Decline Invitation
 */
export const declineInvitationMutation = (
  options?: Partial<Options<DeclineInvitationData>>,
): UseMutationOptions<
  unknown,
  AxiosError<DeclineInvitationError>,
  Options<DeclineInvitationData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    AxiosError<DeclineInvitationError>,
    Options<DeclineInvitationData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await declineInvitation({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Accept Invitation
 */
export const acceptInvitationMutation = (
  options?: Partial<Options<AcceptInvitationData>>,
): UseMutationOptions<
  unknown,
  AxiosError<AcceptInvitationError>,
  Options<AcceptInvitationData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    AxiosError<AcceptInvitationError>,
    Options<AcceptInvitationData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await acceptInvitation({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getTemplateTitlesPublicTitlesGetQueryKey = (
  options?: Options<GetTemplateTitlesPublicTitlesGetData>,
) => createQueryKey('getTemplateTitlesPublicTitlesGet', options);

/**
 * Get Template Titles
 */
export const getTemplateTitlesPublicTitlesGetOptions = (
  options?: Options<GetTemplateTitlesPublicTitlesGetData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getTemplateTitlesPublicTitlesGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getTemplateTitlesPublicTitlesGetQueryKey(options),
  });
};

/**
 * Track Unlock
 */
export const trackUnlockMutation = (
  options?: Partial<Options<TrackUnlockData>>,
): UseMutationOptions<
  unknown,
  AxiosError<TrackUnlockError>,
  Options<TrackUnlockData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    AxiosError<TrackUnlockError>,
    Options<TrackUnlockData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await trackUnlock({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const signedRecordingRecordingsSignedRecordingRoomIdGetQueryKey = (
  options: Options<SignedRecordingRecordingsSignedRecordingRoomIdGetData>,
) =>
  createQueryKey('signedRecordingRecordingsSignedRecordingRoomIdGet', options);

/**
 * Signed Recording
 */
export const signedRecordingRecordingsSignedRecordingRoomIdGetOptions = (
  options: Options<SignedRecordingRecordingsSignedRecordingRoomIdGetData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await signedRecordingRecordingsSignedRecordingRoomIdGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey:
      signedRecordingRecordingsSignedRecordingRoomIdGetQueryKey(options),
  });
};

/**
 * Delete Recording
 */
export const deleteRecordingRecordingsRecordingRoomIdDeleteMutation = (
  options?: Partial<
    Options<DeleteRecordingRecordingsRecordingRoomIdDeleteData>
  >,
): UseMutationOptions<
  unknown,
  AxiosError<DeleteRecordingRecordingsRecordingRoomIdDeleteError>,
  Options<DeleteRecordingRecordingsRecordingRoomIdDeleteData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    AxiosError<DeleteRecordingRecordingsRecordingRoomIdDeleteError>,
    Options<DeleteRecordingRecordingsRecordingRoomIdDeleteData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteRecordingRecordingsRecordingRoomIdDelete({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getConversationTranscriptionRecordingsConversationTranscriptionIdGetQueryKey =
  (
    options: Options<GetConversationTranscriptionRecordingsConversationTranscriptionIdGetData>,
  ) =>
    createQueryKey(
      'getConversationTranscriptionRecordingsConversationTranscriptionIdGet',
      options,
    );

/**
 * Get Conversation Transcription
 *
 * Get transcription in conversation format.
 */
export const getConversationTranscriptionRecordingsConversationTranscriptionIdGetOptions =
  (
    options: Options<GetConversationTranscriptionRecordingsConversationTranscriptionIdGetData>,
  ) => {
    return queryOptions({
      queryFn: async ({ queryKey, signal }) => {
        const { data } =
          await getConversationTranscriptionRecordingsConversationTranscriptionIdGet(
            {
              ...options,
              ...queryKey[0],
              signal,
              throwOnError: true,
            },
          );
        return data;
      },
      queryKey:
        getConversationTranscriptionRecordingsConversationTranscriptionIdGetQueryKey(
          options,
        ),
    });
  };

/**
 * Web
 */
export const webLivekitWebhookPostMutation = (
  options?: Partial<Options<WebLivekitWebhookPostData>>,
): UseMutationOptions<
  unknown,
  AxiosError<WebLivekitWebhookPostError>,
  Options<WebLivekitWebhookPostData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    AxiosError<WebLivekitWebhookPostError>,
    Options<WebLivekitWebhookPostData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await webLivekitWebhookPost({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Assess Session
 */
export const assessSessionMutation = (
  options?: Partial<Options<AssessSessionData>>,
): UseMutationOptions<
  AssessSessionResponse,
  AxiosError<AssessSessionError>,
  Options<AssessSessionData>
> => {
  const mutationOptions: UseMutationOptions<
    AssessSessionResponse,
    AxiosError<AssessSessionError>,
    Options<AssessSessionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await assessSession({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Generate Single Summary
 *
 * Cloud Tasks handler. Return 2xx for permanent failures so tasks stop retrying.
 */
export const generateSingleSummaryLivekitGenerateSingleSummaryPostMutation = (
  options?: Partial<
    Options<GenerateSingleSummaryLivekitGenerateSingleSummaryPostData>
  >,
): UseMutationOptions<
  unknown,
  AxiosError<GenerateSingleSummaryLivekitGenerateSingleSummaryPostError>,
  Options<GenerateSingleSummaryLivekitGenerateSingleSummaryPostData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    AxiosError<GenerateSingleSummaryLivekitGenerateSingleSummaryPostError>,
    Options<GenerateSingleSummaryLivekitGenerateSingleSummaryPostData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } =
        await generateSingleSummaryLivekitGenerateSingleSummaryPost({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Assess Recordings
 *
 * Cloud Tasks handler. Ack permanent 4xx failures so tasks stop retrying.
 */
export const assessRecordingsMutation = (
  options?: Partial<Options<AssessRecordingsData>>,
): UseMutationOptions<
  unknown,
  AxiosError<AssessRecordingsError>,
  Options<AssessRecordingsData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    AxiosError<AssessRecordingsError>,
    Options<AssessRecordingsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await assessRecordings({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Check Camera
 *
 * Cloud Task: label the application with how much of its recording had the camera off.
 */
export const checkCameraMutation = (
  options?: Partial<Options<CheckCameraData>>,
): UseMutationOptions<
  unknown,
  AxiosError<CheckCameraError>,
  Options<CheckCameraData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    AxiosError<CheckCameraError>,
    Options<CheckCameraData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await checkCamera({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Integrity Review
 *
 * Cloud Task: score the recording on 15 integrity criteria. 2xx unless Gemini's quota is hit (then retried).
 */
export const integrityReviewMutation = (
  options?: Partial<Options<IntegrityReviewData>>,
): UseMutationOptions<
  unknown,
  AxiosError<IntegrityReviewError>,
  Options<IntegrityReviewData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    AxiosError<IntegrityReviewError>,
    Options<IntegrityReviewData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await integrityReview({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Assess Recordings Advanced
 */
export const assessRecordingsAdvancedMutation = (
  options?: Partial<Options<AssessRecordingsAdvancedData>>,
): UseMutationOptions<
  unknown,
  AxiosError<AssessRecordingsAdvancedError>,
  Options<AssessRecordingsAdvancedData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    AxiosError<AssessRecordingsAdvancedError>,
    Options<AssessRecordingsAdvancedData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await assessRecordingsAdvanced({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Make Call
 */
export const makeCallLivekitMakeCallPostMutation = (
  options?: Partial<Options<MakeCallLivekitMakeCallPostData>>,
): UseMutationOptions<
  unknown,
  AxiosError<MakeCallLivekitMakeCallPostError>,
  Options<MakeCallLivekitMakeCallPostData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    AxiosError<MakeCallLivekitMakeCallPostError>,
    Options<MakeCallLivekitMakeCallPostData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await makeCallLivekitMakeCallPost({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getTtsVoicesTtsVoicesGetQueryKey = (
  options?: Options<GetTtsVoicesTtsVoicesGetData>,
) => createQueryKey('getTtsVoicesTtsVoicesGet', options);

/**
 * Get Tts Voices
 *
 * Get all available TTS voices from supported providers (OpenAI, ElevenLabs, Google).
 *
 * Returns unified voice information including:
 * - Voice names and IDs
 * - Preview URLs for testing voices
 * - Supported languages and locales
 * - Available models for each provider
 * - Voice metadata (gender, age, accent, etc.)
 */
export const getTtsVoicesTtsVoicesGetOptions = (
  options?: Options<GetTtsVoicesTtsVoicesGetData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getTtsVoicesTtsVoicesGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getTtsVoicesTtsVoicesGetQueryKey(options),
  });
};

export const getTtsProvidersTtsVoicesProvidersGetQueryKey = (
  options?: Options<GetTtsProvidersTtsVoicesProvidersGetData>,
) => createQueryKey('getTtsProvidersTtsVoicesProvidersGet', options);

/**
 * Get Tts Providers
 *
 * Get list of supported TTS providers
 */
export const getTtsProvidersTtsVoicesProvidersGetOptions = (
  options?: Options<GetTtsProvidersTtsVoicesProvidersGetData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getTtsProvidersTtsVoicesProvidersGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getTtsProvidersTtsVoicesProvidersGetQueryKey(options),
  });
};

export const getTtsModelsTtsVoicesModelsGetQueryKey = (
  options?: Options<GetTtsModelsTtsVoicesModelsGetData>,
) => createQueryKey('getTtsModelsTtsVoicesModelsGet', options);

/**
 * Get Tts Models
 *
 * Get available TTS models, optionally filtered by provider
 */
export const getTtsModelsTtsVoicesModelsGetOptions = (
  options?: Options<GetTtsModelsTtsVoicesModelsGetData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getTtsModelsTtsVoicesModelsGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getTtsModelsTtsVoicesModelsGetQueryKey(options),
  });
};

/**
 * Send Feedback
 */
export const sendFeedbackUsersFeedbackPostMutation = (
  options?: Partial<Options<SendFeedbackUsersFeedbackPostData>>,
): UseMutationOptions<
  unknown,
  AxiosError<SendFeedbackUsersFeedbackPostError>,
  Options<SendFeedbackUsersFeedbackPostData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    AxiosError<SendFeedbackUsersFeedbackPostError>,
    Options<SendFeedbackUsersFeedbackPostData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await sendFeedbackUsersFeedbackPost({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Send Rating
 */
export const sendRatingUsersRatingPostMutation = (
  options?: Partial<Options<SendRatingUsersRatingPostData>>,
): UseMutationOptions<
  unknown,
  AxiosError<SendRatingUsersRatingPostError>,
  Options<SendRatingUsersRatingPostData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    AxiosError<SendRatingUsersRatingPostError>,
    Options<SendRatingUsersRatingPostData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await sendRatingUsersRatingPost({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getUserUsersAuthGetQueryKey = (
  options?: Options<GetUserUsersAuthGetData>,
) => createQueryKey('getUserUsersAuthGet', options);

/**
 * Get User
 */
export const getUserUsersAuthGetOptions = (
  options?: Options<GetUserUsersAuthGetData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getUserUsersAuthGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getUserUsersAuthGetQueryKey(options),
  });
};

/**
 * Generate Api Key Endpoint
 *
 * Generate a JWT API key for the company
 *
 * This endpoint generates a signed JWT token that can be used for
 * integrations like Softgarden. The token includes the company_id
 * and is signed with the configured secret.
 */
export const generateApiKeyEndpointUsersGenerateKeyPostMutation = (
  options?: Partial<Options<GenerateApiKeyEndpointUsersGenerateKeyPostData>>,
): UseMutationOptions<
  GenerateApiKeyEndpointUsersGenerateKeyPostResponse,
  AxiosError<GenerateApiKeyEndpointUsersGenerateKeyPostError>,
  Options<GenerateApiKeyEndpointUsersGenerateKeyPostData>
> => {
  const mutationOptions: UseMutationOptions<
    GenerateApiKeyEndpointUsersGenerateKeyPostResponse,
    AxiosError<GenerateApiKeyEndpointUsersGenerateKeyPostError>,
    Options<GenerateApiKeyEndpointUsersGenerateKeyPostData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await generateApiKeyEndpointUsersGenerateKeyPost({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Onboarding Completed
 */
export const onboardingCompletedMutation = (
  options?: Partial<Options<OnboardingCompletedData>>,
): UseMutationOptions<
  OnboardingCompletedResponse,
  AxiosError<OnboardingCompletedError>,
  Options<OnboardingCompletedData>
> => {
  const mutationOptions: UseMutationOptions<
    OnboardingCompletedResponse,
    AxiosError<OnboardingCompletedError>,
    Options<OnboardingCompletedData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await onboardingCompleted({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Send Verification Email
 */
export const sendVerificationEmailMutation = (
  options?: Partial<Options<SendVerificationEmailData>>,
): UseMutationOptions<
  unknown,
  AxiosError<SendVerificationEmailError>,
  Options<SendVerificationEmailData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    AxiosError<SendVerificationEmailError>,
    Options<SendVerificationEmailData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await sendVerificationEmail({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Add Account Type
 */
export const addAccountTypeMutation = (
  options?: Partial<Options<AddAccountTypeData>>,
): UseMutationOptions<
  AddAccountTypeResponse,
  AxiosError<AddAccountTypeError>,
  Options<AddAccountTypeData>
> => {
  const mutationOptions: UseMutationOptions<
    AddAccountTypeResponse,
    AxiosError<AddAccountTypeError>,
    Options<AddAccountTypeData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await addAccountType({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Update Company
 */
export const updateCompanyCompaniesUpdatePutMutation = (
  options?: Partial<Options<UpdateCompanyCompaniesUpdatePutData>>,
): UseMutationOptions<
  unknown,
  AxiosError<UpdateCompanyCompaniesUpdatePutError>,
  Options<UpdateCompanyCompaniesUpdatePutData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    AxiosError<UpdateCompanyCompaniesUpdatePutError>,
    Options<UpdateCompanyCompaniesUpdatePutData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateCompanyCompaniesUpdatePut({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getCompanyCompaniesSingleGetQueryKey = (
  options?: Options<GetCompanyCompaniesSingleGetData>,
) => createQueryKey('getCompanyCompaniesSingleGet', options);

/**
 * Get Company
 */
export const getCompanyCompaniesSingleGetOptions = (
  options?: Options<GetCompanyCompaniesSingleGetData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getCompanyCompaniesSingleGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getCompanyCompaniesSingleGetQueryKey(options),
  });
};

export const getTemplatesTemplatesGetQueryKey = (
  options?: Options<GetTemplatesTemplatesGetData>,
) => createQueryKey('getTemplatesTemplatesGet', options);

/**
 * Get Templates
 */
export const getTemplatesTemplatesGetOptions = (
  options?: Options<GetTemplatesTemplatesGetData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getTemplatesTemplatesGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getTemplatesTemplatesGetQueryKey(options),
  });
};

/**
 * Create Template
 */
export const createTemplateTemplatesPostMutation = (
  options?: Partial<Options<CreateTemplateTemplatesPostData>>,
): UseMutationOptions<
  CreateTemplateTemplatesPostResponse,
  AxiosError<CreateTemplateTemplatesPostError>,
  Options<CreateTemplateTemplatesPostData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateTemplateTemplatesPostResponse,
    AxiosError<CreateTemplateTemplatesPostError>,
    Options<CreateTemplateTemplatesPostData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createTemplateTemplatesPost({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete Template
 */
export const deleteTemplateTemplatesTemplateIdDeleteMutation = (
  options?: Partial<Options<DeleteTemplateTemplatesTemplateIdDeleteData>>,
): UseMutationOptions<
  unknown,
  AxiosError<DeleteTemplateTemplatesTemplateIdDeleteError>,
  Options<DeleteTemplateTemplatesTemplateIdDeleteData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    AxiosError<DeleteTemplateTemplatesTemplateIdDeleteError>,
    Options<DeleteTemplateTemplatesTemplateIdDeleteData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteTemplateTemplatesTemplateIdDelete({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getTemplateTemplatesTemplateIdGetQueryKey = (
  options: Options<GetTemplateTemplatesTemplateIdGetData>,
) => createQueryKey('getTemplateTemplatesTemplateIdGet', options);

/**
 * Get Template
 */
export const getTemplateTemplatesTemplateIdGetOptions = (
  options: Options<GetTemplateTemplatesTemplateIdGetData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getTemplateTemplatesTemplateIdGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getTemplateTemplatesTemplateIdGetQueryKey(options),
  });
};

/**
 * Update Template
 */
export const updateTemplateTemplatesTemplateIdPutMutation = (
  options?: Partial<Options<UpdateTemplateTemplatesTemplateIdPutData>>,
): UseMutationOptions<
  unknown,
  AxiosError<UpdateTemplateTemplatesTemplateIdPutError>,
  Options<UpdateTemplateTemplatesTemplateIdPutData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    AxiosError<UpdateTemplateTemplatesTemplateIdPutError>,
    Options<UpdateTemplateTemplatesTemplateIdPutData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateTemplateTemplatesTemplateIdPut({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Publish Template
 *
 * Publish template by moving draft_mind_config to mind_config and updating last_published_at
 */
export const publishTemplateTemplatesTemplateIdPublishPutMutation = (
  options?: Partial<Options<PublishTemplateTemplatesTemplateIdPublishPutData>>,
): UseMutationOptions<
  unknown,
  AxiosError<PublishTemplateTemplatesTemplateIdPublishPutError>,
  Options<PublishTemplateTemplatesTemplateIdPublishPutData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    AxiosError<PublishTemplateTemplatesTemplateIdPublishPutError>,
    Options<PublishTemplateTemplatesTemplateIdPublishPutData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await publishTemplateTemplatesTemplateIdPublishPut({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Disable Template Sharing
 *
 * Disable sharing for a template
 */
export const disableTemplateSharingTemplatesTemplateIdShareDeleteMutation = (
  options?: Partial<
    Options<DisableTemplateSharingTemplatesTemplateIdShareDeleteData>
  >,
): UseMutationOptions<
  unknown,
  AxiosError<DisableTemplateSharingTemplatesTemplateIdShareDeleteError>,
  Options<DisableTemplateSharingTemplatesTemplateIdShareDeleteData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    AxiosError<DisableTemplateSharingTemplatesTemplateIdShareDeleteError>,
    Options<DisableTemplateSharingTemplatesTemplateIdShareDeleteData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } =
        await disableTemplateSharingTemplatesTemplateIdShareDelete({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
      return data;
    },
  };
  return mutationOptions;
};

export const getTemplateSharingStatusTemplatesTemplateIdShareGetQueryKey = (
  options: Options<GetTemplateSharingStatusTemplatesTemplateIdShareGetData>,
) =>
  createQueryKey(
    'getTemplateSharingStatusTemplatesTemplateIdShareGet',
    options,
  );

/**
 * Get Template Sharing Status
 *
 * Get the current sharing status of a template
 */
export const getTemplateSharingStatusTemplatesTemplateIdShareGetOptions = (
  options: Options<GetTemplateSharingStatusTemplatesTemplateIdShareGetData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } =
        await getTemplateSharingStatusTemplatesTemplateIdShareGet({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
      return data;
    },
    queryKey:
      getTemplateSharingStatusTemplatesTemplateIdShareGetQueryKey(options),
  });
};

/**
 * Enable Template Sharing
 *
 * Enable sharing for a template for 48 hours
 */
export const enableTemplateSharingTemplatesTemplateIdSharePostMutation = (
  options?: Partial<
    Options<EnableTemplateSharingTemplatesTemplateIdSharePostData>
  >,
): UseMutationOptions<
  unknown,
  AxiosError<EnableTemplateSharingTemplatesTemplateIdSharePostError>,
  Options<EnableTemplateSharingTemplatesTemplateIdSharePostData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    AxiosError<EnableTemplateSharingTemplatesTemplateIdSharePostError>,
    Options<EnableTemplateSharingTemplatesTemplateIdSharePostData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await enableTemplateSharingTemplatesTemplateIdSharePost({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getOpenSessionsRoomsOpenSessionsGetQueryKey = (
  options?: Options<GetOpenSessionsRoomsOpenSessionsGetData>,
) => createQueryKey('getOpenSessionsRoomsOpenSessionsGet', options);

/**
 * Get Open Sessions
 */
export const getOpenSessionsRoomsOpenSessionsGetOptions = (
  options?: Options<GetOpenSessionsRoomsOpenSessionsGetData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOpenSessionsRoomsOpenSessionsGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOpenSessionsRoomsOpenSessionsGetQueryKey(options),
  });
};

export const getCompanyInsightsQueryKey = (
  options?: Options<GetCompanyInsightsData>,
) => createQueryKey('getCompanyInsights', options);

/**
 * Get Company Insights
 */
export const getCompanyInsightsOptions = (
  options?: Options<GetCompanyInsightsData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getCompanyInsights({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getCompanyInsightsQueryKey(options),
  });
};

export const getCandidatesRoomsCandidatesGetQueryKey = (
  options?: Options<GetCandidatesRoomsCandidatesGetData>,
) => createQueryKey('getCandidatesRoomsCandidatesGet', options);

/**
 * Get Candidates
 */
export const getCandidatesRoomsCandidatesGetOptions = (
  options?: Options<GetCandidatesRoomsCandidatesGetData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getCandidatesRoomsCandidatesGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getCandidatesRoomsCandidatesGetQueryKey(options),
  });
};

export const getCandidatesRoomsCandidatesGetInfiniteQueryKey = (
  options?: Options<GetCandidatesRoomsCandidatesGetData>,
): QueryKey<Options<GetCandidatesRoomsCandidatesGetData>> =>
  createQueryKey('getCandidatesRoomsCandidatesGet', options, true);

/**
 * Get Candidates
 */
export const getCandidatesRoomsCandidatesGetInfiniteOptions = (
  options?: Options<GetCandidatesRoomsCandidatesGetData>,
) => {
  return infiniteQueryOptions<
    GetCandidatesRoomsCandidatesGetResponse,
    AxiosError<GetCandidatesRoomsCandidatesGetError>,
    InfiniteData<GetCandidatesRoomsCandidatesGetResponse>,
    QueryKey<Options<GetCandidatesRoomsCandidatesGetData>>,
    | number
    | Pick<
        QueryKey<Options<GetCandidatesRoomsCandidatesGetData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetCandidatesRoomsCandidatesGetData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getCandidatesRoomsCandidatesGet({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getCandidatesRoomsCandidatesGetInfiniteQueryKey(options),
    },
  );
};

/**
 * Export Room Summary Csv
 */
export const exportRoomSummaryCsvMutation = (
  options?: Partial<Options<ExportRoomSummaryCsvData>>,
): UseMutationOptions<
  unknown,
  AxiosError<ExportRoomSummaryCsvError>,
  Options<ExportRoomSummaryCsvData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    AxiosError<ExportRoomSummaryCsvError>,
    Options<ExportRoomSummaryCsvData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await exportRoomSummaryCsv({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Export Room Summary Pdf
 */
export const exportRoomSummaryPdfMutation = (
  options?: Partial<Options<ExportRoomSummaryPdfData>>,
): UseMutationOptions<
  ExportRoomSummaryPdfResponse,
  AxiosError<ExportRoomSummaryPdfError>,
  Options<ExportRoomSummaryPdfData>
> => {
  const mutationOptions: UseMutationOptions<
    ExportRoomSummaryPdfResponse,
    AxiosError<ExportRoomSummaryPdfError>,
    Options<ExportRoomSummaryPdfData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await exportRoomSummaryPdf({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Generate Bulk Summaries
 *
 * Generate summaries for multiple applications in batch
 */
export const generateBulkSummariesRoomsGenerateSummaryPostMutation = (
  options?: Partial<Options<GenerateBulkSummariesRoomsGenerateSummaryPostData>>,
): UseMutationOptions<
  GenerateBulkSummariesRoomsGenerateSummaryPostResponse,
  AxiosError<GenerateBulkSummariesRoomsGenerateSummaryPostError>,
  Options<GenerateBulkSummariesRoomsGenerateSummaryPostData>
> => {
  const mutationOptions: UseMutationOptions<
    GenerateBulkSummariesRoomsGenerateSummaryPostResponse,
    AxiosError<GenerateBulkSummariesRoomsGenerateSummaryPostError>,
    Options<GenerateBulkSummariesRoomsGenerateSummaryPostData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await generateBulkSummariesRoomsGenerateSummaryPost({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete Applications
 */
export const deleteApplicationsApplicationsDeleteApplicationsDeleteMutation = (
  options?: Partial<
    Options<DeleteApplicationsApplicationsDeleteApplicationsDeleteData>
  >,
): UseMutationOptions<
  unknown,
  AxiosError<DeleteApplicationsApplicationsDeleteApplicationsDeleteError>,
  Options<DeleteApplicationsApplicationsDeleteApplicationsDeleteData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    AxiosError<DeleteApplicationsApplicationsDeleteApplicationsDeleteError>,
    Options<DeleteApplicationsApplicationsDeleteApplicationsDeleteData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } =
        await deleteApplicationsApplicationsDeleteApplicationsDelete({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Request Call
 */
export const requestCallApplicationsRequestCallPostMutation = (
  options?: Partial<Options<RequestCallApplicationsRequestCallPostData>>,
): UseMutationOptions<
  unknown,
  AxiosError<RequestCallApplicationsRequestCallPostError>,
  Options<RequestCallApplicationsRequestCallPostData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    AxiosError<RequestCallApplicationsRequestCallPostError>,
    Options<RequestCallApplicationsRequestCallPostData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await requestCallApplicationsRequestCallPost({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Cancel Interview
 *
 * The company cancels a candidate's booked interview from the dashboard.
 */
export const cancelInterviewMutation = (
  options?: Partial<Options<CancelInterviewData>>,
): UseMutationOptions<
  CancelInterviewResponse2,
  AxiosError<CancelInterviewError>,
  Options<CancelInterviewData>
> => {
  const mutationOptions: UseMutationOptions<
    CancelInterviewResponse2,
    AxiosError<CancelInterviewError>,
    Options<CancelInterviewData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await cancelInterview({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Archive Application
 */
export const archiveApplicationApplicationsArchivePostMutation = (
  options?: Partial<Options<ArchiveApplicationApplicationsArchivePostData>>,
): UseMutationOptions<
  unknown,
  AxiosError<ArchiveApplicationApplicationsArchivePostError>,
  Options<ArchiveApplicationApplicationsArchivePostData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    AxiosError<ArchiveApplicationApplicationsArchivePostError>,
    Options<ArchiveApplicationApplicationsArchivePostData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await archiveApplicationApplicationsArchivePost({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Update Application Stage
 */
export const updateApplicationStageApplicationsUpdateStagePostMutation = (
  options?: Partial<
    Options<UpdateApplicationStageApplicationsUpdateStagePostData>
  >,
): UseMutationOptions<
  unknown,
  AxiosError<UpdateApplicationStageApplicationsUpdateStagePostError>,
  Options<UpdateApplicationStageApplicationsUpdateStagePostData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    AxiosError<UpdateApplicationStageApplicationsUpdateStagePostError>,
    Options<UpdateApplicationStageApplicationsUpdateStagePostData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateApplicationStageApplicationsUpdateStagePost({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Add Application Comment
 */
export const addApplicationCommentMutation = (
  options?: Partial<Options<AddApplicationCommentData>>,
): UseMutationOptions<
  AddApplicationCommentResponse,
  AxiosError<AddApplicationCommentError>,
  Options<AddApplicationCommentData>
> => {
  const mutationOptions: UseMutationOptions<
    AddApplicationCommentResponse,
    AxiosError<AddApplicationCommentError>,
    Options<AddApplicationCommentData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await addApplicationComment({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getApplicationCommentsQueryKey = (
  options: Options<GetApplicationCommentsData>,
) => createQueryKey('getApplicationComments', options);

/**
 * Get Application Comments
 */
export const getApplicationCommentsOptions = (
  options: Options<GetApplicationCommentsData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getApplicationComments({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getApplicationCommentsQueryKey(options),
  });
};

export const getCandidateFeedbackQueryKey = (
  options?: Options<GetCandidateFeedbackData>,
) => createQueryKey('getCandidateFeedback', options);

/**
 * Get Candidate Feedback
 */
export const getCandidateFeedbackOptions = (
  options?: Options<GetCandidateFeedbackData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getCandidateFeedback({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getCandidateFeedbackQueryKey(options),
  });
};

export const getCandidateFeedbackInfiniteQueryKey = (
  options?: Options<GetCandidateFeedbackData>,
): QueryKey<Options<GetCandidateFeedbackData>> =>
  createQueryKey('getCandidateFeedback', options, true);

/**
 * Get Candidate Feedback
 */
export const getCandidateFeedbackInfiniteOptions = (
  options?: Options<GetCandidateFeedbackData>,
) => {
  return infiniteQueryOptions<
    GetCandidateFeedbackResponse,
    AxiosError<GetCandidateFeedbackError>,
    InfiniteData<GetCandidateFeedbackResponse>,
    QueryKey<Options<GetCandidateFeedbackData>>,
    | number
    | Pick<
        QueryKey<Options<GetCandidateFeedbackData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetCandidateFeedbackData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getCandidateFeedback({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getCandidateFeedbackInfiniteQueryKey(options),
    },
  );
};

export const getCandidatesCountQueryKey = (
  options: Options<GetCandidatesCountData>,
) => createQueryKey('getCandidatesCount', options);

/**
 * Get Candidates Count
 */
export const getCandidatesCountOptions = (
  options: Options<GetCandidatesCountData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getCandidatesCount({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getCandidatesCountQueryKey(options),
  });
};

/**
 * Bulk Delete By Filter
 */
export const bulkDeleteByFilterMutation = (
  options?: Partial<Options<BulkDeleteByFilterData>>,
): UseMutationOptions<
  unknown,
  AxiosError<BulkDeleteByFilterError>,
  Options<BulkDeleteByFilterData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    AxiosError<BulkDeleteByFilterError>,
    Options<BulkDeleteByFilterData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await bulkDeleteByFilter({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Create Test
 */
export const createTestSessionsTestSessionPostMutation = (
  options?: Partial<Options<CreateTestSessionsTestSessionPostData>>,
): UseMutationOptions<
  CreateTestSessionsTestSessionPostResponse,
  AxiosError<CreateTestSessionsTestSessionPostError>,
  Options<CreateTestSessionsTestSessionPostData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateTestSessionsTestSessionPostResponse,
    AxiosError<CreateTestSessionsTestSessionPostError>,
    Options<CreateTestSessionsTestSessionPostData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createTestSessionsTestSessionPost({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Import Candidates
 */
export const importCandidatesSessionsTemplateIdImportPostMutation = (
  options?: Partial<Options<ImportCandidatesSessionsTemplateIdImportPostData>>,
): UseMutationOptions<
  unknown,
  AxiosError<ImportCandidatesSessionsTemplateIdImportPostError>,
  Options<ImportCandidatesSessionsTemplateIdImportPostData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    AxiosError<ImportCandidatesSessionsTemplateIdImportPostError>,
    Options<ImportCandidatesSessionsTemplateIdImportPostData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await importCandidatesSessionsTemplateIdImportPost({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Invite Imported Candidates
 *
 * Invite imported candidates by scheduling interviews and sending invitation emails.
 * Creates cloud tasks to process each invitation asynchronously.
 */
export const inviteImportedCandidatesMutation = (
  options?: Partial<Options<InviteImportedCandidatesData>>,
): UseMutationOptions<
  InviteImportedCandidatesResponse,
  AxiosError<InviteImportedCandidatesError>,
  Options<InviteImportedCandidatesData>
> => {
  const mutationOptions: UseMutationOptions<
    InviteImportedCandidatesResponse,
    AxiosError<InviteImportedCandidatesError>,
    Options<InviteImportedCandidatesData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await inviteImportedCandidates({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getDefaultAssessmentComponentsQueryKey = (
  options?: Options<GetDefaultAssessmentComponentsData>,
) => createQueryKey('getDefaultAssessmentComponents', options);

/**
 * Get Default Assessment Components
 *
 * Get all available default assessment components with their names, descriptions, and IDs
 */
export const getDefaultAssessmentComponentsOptions = (
  options?: Options<GetDefaultAssessmentComponentsData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getDefaultAssessmentComponents({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getDefaultAssessmentComponentsQueryKey(options),
  });
};

export const getAllAssessmentComponentsQueryKey = (
  options?: Options<GetAllAssessmentComponentsData>,
) => createQueryKey('getAllAssessmentComponents', options);

/**
 * Get All Assessment Components
 *
 * Get all available assessment components with their names, descriptions, and IDs
 */
export const getAllAssessmentComponentsOptions = (
  options?: Options<GetAllAssessmentComponentsData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getAllAssessmentComponents({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getAllAssessmentComponentsQueryKey(options),
  });
};

/**
 * Generate Session Template
 *
 * Generate a session template using AI based on user prompt
 */
export const generateSessionTemplateAiGenerationSessionTemplatePostMutation = (
  options?: Partial<
    Options<GenerateSessionTemplateAiGenerationSessionTemplatePostData>
  >,
): UseMutationOptions<
  GenerateSessionTemplateAiGenerationSessionTemplatePostResponse,
  AxiosError<GenerateSessionTemplateAiGenerationSessionTemplatePostError>,
  Options<GenerateSessionTemplateAiGenerationSessionTemplatePostData>
> => {
  const mutationOptions: UseMutationOptions<
    GenerateSessionTemplateAiGenerationSessionTemplatePostResponse,
    AxiosError<GenerateSessionTemplateAiGenerationSessionTemplatePostError>,
    Options<GenerateSessionTemplateAiGenerationSessionTemplatePostData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } =
        await generateSessionTemplateAiGenerationSessionTemplatePost({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
      return data;
    },
  };
  return mutationOptions;
};

export const getAvailableLlmModelsQueryKey = (
  options?: Options<GetAvailableLlmModelsData>,
) => createQueryKey('getAvailableLlmModels', options);

/**
 * Get Available Llm Models
 */
export const getAvailableLlmModelsOptions = (
  options?: Options<GetAvailableLlmModelsData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getAvailableLlmModels({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getAvailableLlmModelsQueryKey(options),
  });
};

export const listVerticalPacksQueryKey = (
  options?: Options<ListVerticalPacksData>,
) => createQueryKey('listVerticalPacks', options);

/**
 * List Vertical Packs Endpoint
 */
export const listVerticalPacksOptions = (
  options?: Options<ListVerticalPacksData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listVerticalPacks({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listVerticalPacksQueryKey(options),
  });
};

/**
 * Preview Vertical Packs Endpoint
 */
export const previewVerticalPacksMutation = (
  options?: Partial<Options<PreviewVerticalPacksData>>,
): UseMutationOptions<
  PreviewVerticalPacksResponse,
  AxiosError<PreviewVerticalPacksError>,
  Options<PreviewVerticalPacksData>
> => {
  const mutationOptions: UseMutationOptions<
    PreviewVerticalPacksResponse,
    AxiosError<PreviewVerticalPacksError>,
    Options<PreviewVerticalPacksData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await previewVerticalPacks({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Upload Pdf
 */
export const uploadPdfKnowledgeMutation = (
  options?: Partial<Options<UploadPdfKnowledgeData>>,
): UseMutationOptions<
  UploadPdfKnowledgeResponse,
  AxiosError<UploadPdfKnowledgeError>,
  Options<UploadPdfKnowledgeData>
> => {
  const mutationOptions: UseMutationOptions<
    UploadPdfKnowledgeResponse,
    AxiosError<UploadPdfKnowledgeError>,
    Options<UploadPdfKnowledgeData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await uploadPdfKnowledge({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Upload Image
 */
export const uploadImageKnowledgeMutation = (
  options?: Partial<Options<UploadImageKnowledgeData>>,
): UseMutationOptions<
  UploadImageKnowledgeResponse,
  AxiosError<UploadImageKnowledgeError>,
  Options<UploadImageKnowledgeData>
> => {
  const mutationOptions: UseMutationOptions<
    UploadImageKnowledgeResponse,
    AxiosError<UploadImageKnowledgeError>,
    Options<UploadImageKnowledgeData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await uploadImageKnowledge({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Upload Listening
 */
export const uploadListeningKnowledgeMutation = (
  options?: Partial<Options<UploadListeningKnowledgeData>>,
): UseMutationOptions<
  UploadListeningKnowledgeResponse,
  AxiosError<UploadListeningKnowledgeError>,
  Options<UploadListeningKnowledgeData>
> => {
  const mutationOptions: UseMutationOptions<
    UploadListeningKnowledgeResponse,
    AxiosError<UploadListeningKnowledgeError>,
    Options<UploadListeningKnowledgeData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await uploadListeningKnowledge({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Upload Mp4
 */
export const uploadMp4KnowledgeMutation = (
  options?: Partial<Options<UploadMp4KnowledgeData>>,
): UseMutationOptions<
  UploadMp4KnowledgeResponse,
  AxiosError<UploadMp4KnowledgeError>,
  Options<UploadMp4KnowledgeData>
> => {
  const mutationOptions: UseMutationOptions<
    UploadMp4KnowledgeResponse,
    AxiosError<UploadMp4KnowledgeError>,
    Options<UploadMp4KnowledgeData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await uploadMp4Knowledge({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Upload Youtube
 */
export const uploadYoutubeKnowledgeMutation = (
  options?: Partial<Options<UploadYoutubeKnowledgeData>>,
): UseMutationOptions<
  UploadYoutubeKnowledgeResponse,
  AxiosError<UploadYoutubeKnowledgeError>,
  Options<UploadYoutubeKnowledgeData>
> => {
  const mutationOptions: UseMutationOptions<
    UploadYoutubeKnowledgeResponse,
    AxiosError<UploadYoutubeKnowledgeError>,
    Options<UploadYoutubeKnowledgeData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await uploadYoutubeKnowledge({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getKnowledgeByTemplateQueryKey = (
  options: Options<GetKnowledgeByTemplateData>,
) => createQueryKey('getKnowledgeByTemplate', options);

/**
 * List By Template
 */
export const getKnowledgeByTemplateOptions = (
  options: Options<GetKnowledgeByTemplateData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getKnowledgeByTemplate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getKnowledgeByTemplateQueryKey(options),
  });
};

/**
 * Delete Knowledge Item
 */
export const deleteKnowledgeItemMutation = (
  options?: Partial<Options<DeleteKnowledgeItemData>>,
): UseMutationOptions<
  DeleteKnowledgeItemResponse,
  AxiosError<DeleteKnowledgeItemError>,
  Options<DeleteKnowledgeItemData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteKnowledgeItemResponse,
    AxiosError<DeleteKnowledgeItemError>,
    Options<DeleteKnowledgeItemData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteKnowledgeItem({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Generate Images
 *
 * Generate AI images for a session template based on its instructions.
 */
export const generateKnowledgeImagesMutation = (
  options?: Partial<Options<GenerateKnowledgeImagesData>>,
): UseMutationOptions<
  GenerateKnowledgeImagesResponse,
  AxiosError<GenerateKnowledgeImagesError>,
  Options<GenerateKnowledgeImagesData>
> => {
  const mutationOptions: UseMutationOptions<
    GenerateKnowledgeImagesResponse,
    AxiosError<GenerateKnowledgeImagesError>,
    Options<GenerateKnowledgeImagesData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await generateKnowledgeImages({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const listSessionGroupsQueryKey = (
  options?: Options<ListSessionGroupsData>,
) => createQueryKey('listSessionGroups', options);

/**
 * List Groups
 */
export const listSessionGroupsOptions = (
  options?: Options<ListSessionGroupsData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listSessionGroups({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listSessionGroupsQueryKey(options),
  });
};

/**
 * Create Group
 */
export const createSessionGroupMutation = (
  options?: Partial<Options<CreateSessionGroupData>>,
): UseMutationOptions<
  CreateSessionGroupResponse,
  AxiosError<CreateSessionGroupError>,
  Options<CreateSessionGroupData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateSessionGroupResponse,
    AxiosError<CreateSessionGroupError>,
    Options<CreateSessionGroupData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createSessionGroup({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete Group
 */
export const deleteSessionGroupMutation = (
  options?: Partial<Options<DeleteSessionGroupData>>,
): UseMutationOptions<
  unknown,
  AxiosError<DeleteSessionGroupError>,
  Options<DeleteSessionGroupData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    AxiosError<DeleteSessionGroupError>,
    Options<DeleteSessionGroupData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteSessionGroup({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getSessionGroupQueryKey = (
  options: Options<GetSessionGroupData>,
) => createQueryKey('getSessionGroup', options);

/**
 * Get Group
 */
export const getSessionGroupOptions = (
  options: Options<GetSessionGroupData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getSessionGroup({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getSessionGroupQueryKey(options),
  });
};

/**
 * Update Group
 */
export const updateSessionGroupMutation = (
  options?: Partial<Options<UpdateSessionGroupData>>,
): UseMutationOptions<
  unknown,
  AxiosError<UpdateSessionGroupError>,
  Options<UpdateSessionGroupData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    AxiosError<UpdateSessionGroupError>,
    Options<UpdateSessionGroupData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateSessionGroup({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Reorder Group
 */
export const orderSessionGroupTemplatesMutation = (
  options?: Partial<Options<OrderSessionGroupTemplatesData>>,
): UseMutationOptions<
  unknown,
  AxiosError<OrderSessionGroupTemplatesError>,
  Options<OrderSessionGroupTemplatesData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    AxiosError<OrderSessionGroupTemplatesError>,
    Options<OrderSessionGroupTemplatesData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await orderSessionGroupTemplates({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Publish Group
 */
export const publishSessionGroupMutation = (
  options?: Partial<Options<PublishSessionGroupData>>,
): UseMutationOptions<
  unknown,
  AxiosError<PublishSessionGroupError>,
  Options<PublishSessionGroupData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    AxiosError<PublishSessionGroupError>,
    Options<PublishSessionGroupData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await publishSessionGroup({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Unpublish Group
 */
export const unpublishSessionGroupMutation = (
  options?: Partial<Options<UnpublishSessionGroupData>>,
): UseMutationOptions<
  unknown,
  AxiosError<UnpublishSessionGroupError>,
  Options<UnpublishSessionGroupData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    AxiosError<UnpublishSessionGroupError>,
    Options<UnpublishSessionGroupData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await unpublishSessionGroup({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getPublicSessionGroupQueryKey = (
  options: Options<GetPublicSessionGroupData>,
) => createQueryKey('getPublicSessionGroup', options);

/**
 * Get Public Group
 */
export const getPublicSessionGroupOptions = (
  options: Options<GetPublicSessionGroupData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getPublicSessionGroup({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getPublicSessionGroupQueryKey(options),
  });
};

/**
 * Create Stage
 */
export const createStageMutation = (
  options?: Partial<Options<CreateStageData>>,
): UseMutationOptions<
  CreateStageResponse,
  AxiosError<CreateStageError>,
  Options<CreateStageData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateStageResponse,
    AxiosError<CreateStageError>,
    Options<CreateStageData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createStage({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getStagesQueryKey = (options: Options<GetStagesData>) =>
  createQueryKey('getStages', options);

/**
 * Get Stages
 */
export const getStagesOptions = (options: Options<GetStagesData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getStages({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getStagesQueryKey(options),
  });
};

/**
 * Rename Stage
 */
export const renameStageMutation = (
  options?: Partial<Options<RenameStageData>>,
): UseMutationOptions<
  RenameStageResponse,
  AxiosError<RenameStageError>,
  Options<RenameStageData>
> => {
  const mutationOptions: UseMutationOptions<
    RenameStageResponse,
    AxiosError<RenameStageError>,
    Options<RenameStageData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await renameStage({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete Stage
 */
export const deleteStageMutation = (
  options?: Partial<Options<DeleteStageData>>,
): UseMutationOptions<
  unknown,
  AxiosError<DeleteStageError>,
  Options<DeleteStageData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    AxiosError<DeleteStageError>,
    Options<DeleteStageData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteStage({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getLearnSessionsQueryKey = (
  options?: Options<GetLearnSessionsData>,
) => createQueryKey('getLearnSessions', options);

/**
 * Get Learn Sessions
 */
export const getLearnSessionsOptions = (
  options?: Options<GetLearnSessionsData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getLearnSessions({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getLearnSessionsQueryKey(options),
  });
};

export const getLearnSessionsInfiniteQueryKey = (
  options?: Options<GetLearnSessionsData>,
): QueryKey<Options<GetLearnSessionsData>> =>
  createQueryKey('getLearnSessions', options, true);

/**
 * Get Learn Sessions
 */
export const getLearnSessionsInfiniteOptions = (
  options?: Options<GetLearnSessionsData>,
) => {
  return infiniteQueryOptions<
    GetLearnSessionsResponse,
    AxiosError<GetLearnSessionsError>,
    InfiniteData<GetLearnSessionsResponse>,
    QueryKey<Options<GetLearnSessionsData>>,
    | number
    | Pick<
        QueryKey<Options<GetLearnSessionsData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetLearnSessionsData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getLearnSessions({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getLearnSessionsInfiniteQueryKey(options),
    },
  );
};

export const getPopularLearnSessionsQueryKey = (
  options?: Options<GetPopularLearnSessionsData>,
) => createQueryKey('getPopularLearnSessions', options);

/**
 * Get Popular Sessions
 */
export const getPopularLearnSessionsOptions = (
  options?: Options<GetPopularLearnSessionsData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getPopularLearnSessions({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getPopularLearnSessionsQueryKey(options),
  });
};

export const getLearnCategoriesQueryKey = (
  options?: Options<GetLearnCategoriesData>,
) => createQueryKey('getLearnCategories', options);

/**
 * Get Categories
 */
export const getLearnCategoriesOptions = (
  options?: Options<GetLearnCategoriesData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getLearnCategories({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getLearnCategoriesQueryKey(options),
  });
};

export const getLearnSessionGroupsQueryKey = (
  options?: Options<GetLearnSessionGroupsData>,
) => createQueryKey('getLearnSessionGroups', options);

/**
 * Get Session Groups
 */
export const getLearnSessionGroupsOptions = (
  options?: Options<GetLearnSessionGroupsData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getLearnSessionGroups({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getLearnSessionGroupsQueryKey(options),
  });
};

export const getFeaturedSessionGroupsQueryKey = (
  options?: Options<GetFeaturedSessionGroupsData>,
) => createQueryKey('getFeaturedSessionGroups', options);

/**
 * Get Featured Session Groups
 */
export const getFeaturedSessionGroupsOptions = (
  options?: Options<GetFeaturedSessionGroupsData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getFeaturedSessionGroups({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getFeaturedSessionGroupsQueryKey(options),
  });
};

export const getLearnSessionGroupDetailQueryKey = (
  options: Options<GetLearnSessionGroupDetailData>,
) => createQueryKey('getLearnSessionGroupDetail', options);

/**
 * Get Session Group Detail
 *
 * Get detailed session group info for learner view. Accepts public_id or _id.
 */
export const getLearnSessionGroupDetailOptions = (
  options: Options<GetLearnSessionGroupDetailData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getLearnSessionGroupDetail({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getLearnSessionGroupDetailQueryKey(options),
  });
};

export const getGroupVisualizationStatusQueryKey = (
  options: Options<GetGroupVisualizationStatusData>,
) => createQueryKey('getGroupVisualizationStatus', options);

/**
 * Get Group Visualization Status
 *
 * Get real-time visualization generation status for all sessions in a group.
 */
export const getGroupVisualizationStatusOptions = (
  options: Options<GetGroupVisualizationStatusData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getGroupVisualizationStatus({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getGroupVisualizationStatusQueryKey(options),
  });
};

export const listGenerationGalleryQueryKey = (
  options?: Options<ListGenerationGalleryData>,
) => createQueryKey('listGenerationGallery', options);

/**
 * List Generation Gallery
 */
export const listGenerationGalleryOptions = (
  options?: Options<ListGenerationGalleryData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listGenerationGallery({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listGenerationGalleryQueryKey(options),
  });
};

export const getMyGamificationQueryKey = (
  options?: Options<GetMyGamificationData>,
) => createQueryKey('getMyGamification', options);

/**
 * Get My Gamification
 */
export const getMyGamificationOptions = (
  options?: Options<GetMyGamificationData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getMyGamification({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getMyGamificationQueryKey(options),
  });
};

/**
 * Enroll In Session Group
 */
export const enrollInSessionGroupMutation = (
  options?: Partial<Options<EnrollInSessionGroupData>>,
): UseMutationOptions<
  unknown,
  AxiosError<EnrollInSessionGroupError>,
  Options<EnrollInSessionGroupData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    AxiosError<EnrollInSessionGroupError>,
    Options<EnrollInSessionGroupData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await enrollInSessionGroup({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getMyEnrollmentsQueryKey = (
  options?: Options<GetMyEnrollmentsData>,
) => createQueryKey('getMyEnrollments', options);

/**
 * Get My Enrollments
 */
export const getMyEnrollmentsOptions = (
  options?: Options<GetMyEnrollmentsData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getMyEnrollments({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getMyEnrollmentsQueryKey(options),
  });
};

export const getMySessionResultQueryKey = (
  options: Options<GetMySessionResultData>,
) => createQueryKey('getMySessionResult', options);

/**
 * Get My Session Result
 *
 * Get the learner's most recent completed application for a session template.
 */
export const getMySessionResultOptions = (
  options: Options<GetMySessionResultData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getMySessionResult({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getMySessionResultQueryKey(options),
  });
};

/**
 * Toggle Learning Path Visibility
 *
 * Allow the owner to hide/show their learning path from the explore page.
 */
export const toggleLearningPathVisibilityMutation = (
  options?: Partial<Options<ToggleLearningPathVisibilityData>>,
): UseMutationOptions<
  unknown,
  AxiosError<ToggleLearningPathVisibilityError>,
  Options<ToggleLearningPathVisibilityData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    AxiosError<ToggleLearningPathVisibilityError>,
    Options<ToggleLearningPathVisibilityData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await toggleLearningPathVisibility({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Upload Cover Image
 *
 * Upload a custom cover image for a learning path (owner only).
 */
export const uploadLearningPathCoverImageMutation = (
  options?: Partial<Options<UploadLearningPathCoverImageData>>,
): UseMutationOptions<
  unknown,
  AxiosError<UploadLearningPathCoverImageError>,
  Options<UploadLearningPathCoverImageData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    AxiosError<UploadLearningPathCoverImageError>,
    Options<UploadLearningPathCoverImageData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await uploadLearningPathCoverImage({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Generate Learning Path
 *
 * Generate a complete learning path with multiple sessions from a prompt.
 */
export const generateLearningPathMutation = (
  options?: Partial<Options<GenerateLearningPathData>>,
): UseMutationOptions<
  unknown,
  AxiosError<GenerateLearningPathError>,
  Options<GenerateLearningPathData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    AxiosError<GenerateLearningPathError>,
    Options<GenerateLearningPathData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await generateLearningPath({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Upload Learning Document
 *
 * Upload a PDF (book, lesson notes) to generate lessons from.
 */
export const uploadLearningDocumentMutation = (
  options?: Partial<Options<UploadLearningDocumentData>>,
): UseMutationOptions<
  UploadLearningDocumentResponse,
  AxiosError<UploadLearningDocumentError>,
  Options<UploadLearningDocumentData>
> => {
  const mutationOptions: UseMutationOptions<
    UploadLearningDocumentResponse,
    AxiosError<UploadLearningDocumentError>,
    Options<UploadLearningDocumentData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await uploadLearningDocument({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Import Learning Document Url
 *
 * Scrape a web page or PDF link (text and images) to generate lessons from.
 */
export const importLearningDocumentUrlMutation = (
  options?: Partial<Options<ImportLearningDocumentUrlData>>,
): UseMutationOptions<
  ImportLearningDocumentUrlResponse,
  AxiosError<ImportLearningDocumentUrlError>,
  Options<ImportLearningDocumentUrlData>
> => {
  const mutationOptions: UseMutationOptions<
    ImportLearningDocumentUrlResponse,
    AxiosError<ImportLearningDocumentUrlError>,
    Options<ImportLearningDocumentUrlData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await importLearningDocumentUrl({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const listLibraryBooksQueryKey = (
  options?: Options<ListLibraryBooksData>,
) => createQueryKey('listLibraryBooks', options);

/**
 * List Library Books
 *
 * Open textbooks (OpenStax) a learner can pick a chapter from.
 */
export const listLibraryBooksOptions = (
  options?: Options<ListLibraryBooksData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listLibraryBooks({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listLibraryBooksQueryKey(options),
  });
};

export const getLibraryBookQueryKey = (options: Options<GetLibraryBookData>) =>
  createQueryKey('getLibraryBook', options);

/**
 * Get Library Book
 */
export const getLibraryBookOptions = (options: Options<GetLibraryBookData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getLibraryBook({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getLibraryBookQueryKey(options),
  });
};

/**
 * Import Library Chapter
 *
 * Turn one chapter of an open textbook into a learning document.
 */
export const importLibraryChapterMutation = (
  options?: Partial<Options<ImportLibraryChapterData>>,
): UseMutationOptions<
  ImportLibraryChapterResponse,
  AxiosError<ImportLibraryChapterError>,
  Options<ImportLibraryChapterData>
> => {
  const mutationOptions: UseMutationOptions<
    ImportLibraryChapterResponse,
    AxiosError<ImportLibraryChapterError>,
    Options<ImportLibraryChapterData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await importLibraryChapter({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getLearningDocumentQueryKey = (
  options: Options<GetLearningDocumentData>,
) => createQueryKey('getLearningDocument', options);

/**
 * Get Learning Document
 */
export const getLearningDocumentOptions = (
  options: Options<GetLearningDocumentData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getLearningDocument({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getLearningDocumentQueryKey(options),
  });
};

/**
 * Generate Learning Path Chat
 *
 * Stream creation of a single session or a session group from chat using the AI SDK data stream protocol.
 */
export const generateLearningPathChatMutation = (
  options?: Partial<Options<GenerateLearningPathChatData>>,
): UseMutationOptions<
  unknown,
  AxiosError<GenerateLearningPathChatError>,
  Options<GenerateLearningPathChatData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    AxiosError<GenerateLearningPathChatError>,
    Options<GenerateLearningPathChatData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await generateLearningPathChat({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Chat Followup
 *
 * Follow-up chat for an existing learning path: course questions, language, and voice.
 */
export const chatFollowupMutation = (
  options?: Partial<Options<ChatFollowupData>>,
): UseMutationOptions<
  unknown,
  AxiosError<ChatFollowupError>,
  Options<ChatFollowupData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    AxiosError<ChatFollowupError>,
    Options<ChatFollowupData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await chatFollowup({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Generate User Learning Path
 *
 * Generate a personalized learning path for a user based on their session and email it to them.
 */
export const generateUserLearningPathMutation = (
  options?: Partial<Options<GenerateUserLearningPathData>>,
): UseMutationOptions<
  GenerateUserLearningPathResponse2,
  AxiosError<GenerateUserLearningPathError>,
  Options<GenerateUserLearningPathData>
> => {
  const mutationOptions: UseMutationOptions<
    GenerateUserLearningPathResponse2,
    AxiosError<GenerateUserLearningPathError>,
    Options<GenerateUserLearningPathData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await generateUserLearningPath({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Link Session To User
 *
 * Link an anonymous session to a registered user. Email must match.
 */
export const linkSessionToUserMutation = (
  options?: Partial<Options<LinkSessionToUserData>>,
): UseMutationOptions<
  unknown,
  AxiosError<LinkSessionToUserError>,
  Options<LinkSessionToUserData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    AxiosError<LinkSessionToUserError>,
    Options<LinkSessionToUserData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await linkSessionToUser({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getReviewStudioAccessQueryKey = (
  options?: Options<GetReviewStudioAccessData>,
) => createQueryKey('getReviewStudioAccess', options);

/**
 * Get Review Studio Access
 *
 * Whether this signed-in company user may open Review Studio. Never 403s — returns allowed=false.
 */
export const getReviewStudioAccessOptions = (
  options?: Options<GetReviewStudioAccessData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getReviewStudioAccess({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getReviewStudioAccessQueryKey(options),
  });
};

export const searchReviewSessionsQueryKey = (
  options?: Options<SearchReviewSessionsData>,
) => createQueryKey('searchReviewSessions', options);

/**
 * Search Review Sessions
 *
 * List latest live tutoring sessions for Review Studio, with search filters.
 */
export const searchReviewSessionsOptions = (
  options?: Options<SearchReviewSessionsData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await searchReviewSessions({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: searchReviewSessionsQueryKey(options),
  });
};

export const searchReviewSessionsInfiniteQueryKey = (
  options?: Options<SearchReviewSessionsData>,
): QueryKey<Options<SearchReviewSessionsData>> =>
  createQueryKey('searchReviewSessions', options, true);

/**
 * Search Review Sessions
 *
 * List latest live tutoring sessions for Review Studio, with search filters.
 */
export const searchReviewSessionsInfiniteOptions = (
  options?: Options<SearchReviewSessionsData>,
) => {
  return infiniteQueryOptions<
    SearchReviewSessionsResponse,
    AxiosError<SearchReviewSessionsError>,
    InfiniteData<SearchReviewSessionsResponse>,
    QueryKey<Options<SearchReviewSessionsData>>,
    | number
    | Pick<
        QueryKey<Options<SearchReviewSessionsData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<SearchReviewSessionsData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await searchReviewSessions({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: searchReviewSessionsInfiniteQueryKey(options),
    },
  );
};

export const getReviewSessionQueryKey = (
  options: Options<GetReviewSessionData>,
) => createQueryKey('getReviewSession', options);

/**
 * Get Review Session
 *
 * Interleaved timeline, prompts, materials, and video stories for one live session.
 */
export const getReviewSessionOptions = (
  options: Options<GetReviewSessionData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getReviewSession({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getReviewSessionQueryKey(options),
  });
};

/**
 * Upsert Review Session Annotation
 *
 * Create or update a human annotation on a session or timeline item.
 */
export const upsertReviewSessionAnnotationMutation = (
  options?: Partial<Options<UpsertReviewSessionAnnotationData>>,
): UseMutationOptions<
  UpsertReviewSessionAnnotationResponse,
  AxiosError<UpsertReviewSessionAnnotationError>,
  Options<UpsertReviewSessionAnnotationData>
> => {
  const mutationOptions: UseMutationOptions<
    UpsertReviewSessionAnnotationResponse,
    AxiosError<UpsertReviewSessionAnnotationError>,
    Options<UpsertReviewSessionAnnotationData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await upsertReviewSessionAnnotation({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Fork Review Session
 *
 * Copy the session into a new room that continues the conversation after one transcript line.
 */
export const forkReviewSessionMutation = (
  options?: Partial<Options<ForkReviewSessionData>>,
): UseMutationOptions<
  ForkReviewSessionResponse2,
  AxiosError<ForkReviewSessionError>,
  Options<ForkReviewSessionData>
> => {
  const mutationOptions: UseMutationOptions<
    ForkReviewSessionResponse2,
    AxiosError<ForkReviewSessionError>,
    Options<ForkReviewSessionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await forkReviewSession({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Queue Review Video Retry
 *
 * Store retry params on a video story. Prefer /reviews/generations/{id}/retry for regen.
 */
export const queueReviewVideoRetryMutation = (
  options?: Partial<Options<QueueReviewVideoRetryData>>,
): UseMutationOptions<
  QueueReviewVideoRetryResponse,
  AxiosError<QueueReviewVideoRetryError>,
  Options<QueueReviewVideoRetryData>
> => {
  const mutationOptions: UseMutationOptions<
    QueueReviewVideoRetryResponse,
    AxiosError<QueueReviewVideoRetryError>,
    Options<QueueReviewVideoRetryData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await queueReviewVideoRetry({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const listReviewGenerationsQueryKey = (
  options?: Options<ListReviewGenerationsData>,
) => createQueryKey('listReviewGenerations', options);

/**
 * List Review Generations
 *
 * List chat-driven generation runs for Generation Inspector.
 */
export const listReviewGenerationsOptions = (
  options?: Options<ListReviewGenerationsData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listReviewGenerations({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listReviewGenerationsQueryKey(options),
  });
};

export const listReviewGenerationsInfiniteQueryKey = (
  options?: Options<ListReviewGenerationsData>,
): QueryKey<Options<ListReviewGenerationsData>> =>
  createQueryKey('listReviewGenerations', options, true);

/**
 * List Review Generations
 *
 * List chat-driven generation runs for Generation Inspector.
 */
export const listReviewGenerationsInfiniteOptions = (
  options?: Options<ListReviewGenerationsData>,
) => {
  return infiniteQueryOptions<
    ListReviewGenerationsResponse,
    AxiosError<ListReviewGenerationsError>,
    InfiniteData<ListReviewGenerationsResponse>,
    QueryKey<Options<ListReviewGenerationsData>>,
    | number
    | Pick<
        QueryKey<Options<ListReviewGenerationsData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ListReviewGenerationsData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listReviewGenerations({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: listReviewGenerationsInfiniteQueryKey(options),
    },
  );
};

export const getReviewGenerationQueryKey = (
  options: Options<GetReviewGenerationData>,
) => createQueryKey('getReviewGeneration', options);

/**
 * Get Review Generation
 *
 * Full low-level generation tree: strategy, plan, stills, keyframes, clips.
 */
export const getReviewGenerationOptions = (
  options: Options<GetReviewGenerationData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getReviewGeneration({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getReviewGenerationQueryKey(options),
  });
};

/**
 * Upsert Review Generation Review
 *
 * Taste / quality / hallucination score on a generation run or child artifact.
 */
export const upsertReviewGenerationReviewMutation = (
  options?: Partial<Options<UpsertReviewGenerationReviewData>>,
): UseMutationOptions<
  UpsertReviewGenerationReviewResponse,
  AxiosError<UpsertReviewGenerationReviewError>,
  Options<UpsertReviewGenerationReviewData>
> => {
  const mutationOptions: UseMutationOptions<
    UpsertReviewGenerationReviewResponse,
    AxiosError<UpsertReviewGenerationReviewError>,
    Options<UpsertReviewGenerationReviewData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await upsertReviewGenerationReview({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Retry Review Generation Artifact
 *
 * Edit prompt and regen one cover / still / keyframe / clip.
 */
export const retryReviewGenerationArtifactMutation = (
  options?: Partial<Options<RetryReviewGenerationArtifactData>>,
): UseMutationOptions<
  RetryReviewGenerationArtifactResponse,
  AxiosError<RetryReviewGenerationArtifactError>,
  Options<RetryReviewGenerationArtifactData>
> => {
  const mutationOptions: UseMutationOptions<
    RetryReviewGenerationArtifactResponse,
    AxiosError<RetryReviewGenerationArtifactError>,
    Options<RetryReviewGenerationArtifactData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await retryReviewGenerationArtifact({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getEvalDashboardQueryKey = (
  options?: Options<GetEvalDashboardData>,
) => createQueryKey('getEvalDashboard', options);

/**
 * Get Dashboard
 *
 * Baselines and score history per fixture, runs in progress, evaluators, labeling progress.
 */
export const getEvalDashboardOptions = (
  options?: Options<GetEvalDashboardData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getEvalDashboard({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getEvalDashboardQueryKey(options),
  });
};

export const getEvalOptionsQueryKey = (options?: Options<GetEvalOptionsData>) =>
  createQueryKey('getEvalOptions', options);

/**
 * Get Options
 */
export const getEvalOptionsOptions = (
  options?: Options<GetEvalOptionsData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getEvalOptions({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getEvalOptionsQueryKey(options),
  });
};

export const listEvalFixturesQueryKey = (
  options?: Options<ListEvalFixturesData>,
) => createQueryKey('listEvalFixtures', options);

/**
 * List Fixtures
 */
export const listEvalFixturesOptions = (
  options?: Options<ListEvalFixturesData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listEvalFixtures({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listEvalFixturesQueryKey(options),
  });
};

/**
 * Create Fixture
 *
 * Freeze a session template as an eval fixture.
 */
export const createEvalFixtureMutation = (
  options?: Partial<Options<CreateEvalFixtureData>>,
): UseMutationOptions<
  CreateEvalFixtureResponse,
  AxiosError<CreateEvalFixtureError>,
  Options<CreateEvalFixtureData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateEvalFixtureResponse,
    AxiosError<CreateEvalFixtureError>,
    Options<CreateEvalFixtureData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createEvalFixture({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Update Fixture
 */
export const updateEvalFixtureMutation = (
  options?: Partial<Options<UpdateEvalFixtureData>>,
): UseMutationOptions<
  UpdateEvalFixtureResponse,
  AxiosError<UpdateEvalFixtureError>,
  Options<UpdateEvalFixtureData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateEvalFixtureResponse,
    AxiosError<UpdateEvalFixtureError>,
    Options<UpdateEvalFixtureData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateEvalFixture({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const listEvalExperimentsQueryKey = (
  options?: Options<ListEvalExperimentsData>,
) => createQueryKey('listEvalExperiments', options);

/**
 * List Experiments
 */
export const listEvalExperimentsOptions = (
  options?: Options<ListEvalExperimentsData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listEvalExperiments({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listEvalExperimentsQueryKey(options),
  });
};

/**
 * Create Experiment
 *
 * Queue live runs for fixtures × personas × learner voices; the local runner picks them up.
 */
export const createEvalExperimentMutation = (
  options?: Partial<Options<CreateEvalExperimentData>>,
): UseMutationOptions<
  CreateEvalExperimentResponse,
  AxiosError<CreateEvalExperimentError>,
  Options<CreateEvalExperimentData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateEvalExperimentResponse,
    AxiosError<CreateEvalExperimentError>,
    Options<CreateEvalExperimentData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createEvalExperiment({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getEvalExperimentQueryKey = (
  options: Options<GetEvalExperimentData>,
) => createQueryKey('getEvalExperiment', options);

/**
 * Get Experiment
 */
export const getEvalExperimentOptions = (
  options: Options<GetEvalExperimentData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getEvalExperiment({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getEvalExperimentQueryKey(options),
  });
};

/**
 * Set Baseline
 *
 * Make this experiment the baseline of every fixture it ran.
 */
export const setEvalBaselineMutation = (
  options?: Partial<Options<SetEvalBaselineData>>,
): UseMutationOptions<
  SetEvalBaselineResponse,
  AxiosError<SetEvalBaselineError>,
  Options<SetEvalBaselineData>
> => {
  const mutationOptions: UseMutationOptions<
    SetEvalBaselineResponse,
    AxiosError<SetEvalBaselineError>,
    Options<SetEvalBaselineData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await setEvalBaseline({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Cancel Experiment
 */
export const cancelEvalExperimentMutation = (
  options?: Partial<Options<CancelEvalExperimentData>>,
): UseMutationOptions<
  CancelEvalExperimentResponse,
  AxiosError<CancelEvalExperimentError>,
  Options<CancelEvalExperimentData>
> => {
  const mutationOptions: UseMutationOptions<
    CancelEvalExperimentResponse,
    AxiosError<CancelEvalExperimentError>,
    Options<CancelEvalExperimentData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await cancelEvalExperiment({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Evaluate Experiment
 *
 * Re-score every finished run with the current evaluator versions (the runner does the work).
 */
export const evaluateEvalExperimentMutation = (
  options?: Partial<Options<EvaluateEvalExperimentData>>,
): UseMutationOptions<
  EvaluateEvalExperimentResponse,
  AxiosError<EvaluateEvalExperimentError>,
  Options<EvaluateEvalExperimentData>
> => {
  const mutationOptions: UseMutationOptions<
    EvaluateEvalExperimentResponse,
    AxiosError<EvaluateEvalExperimentError>,
    Options<EvaluateEvalExperimentData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await evaluateEvalExperiment({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const listEvalRunsQueryKey = (options?: Options<ListEvalRunsData>) =>
  createQueryKey('listEvalRuns', options);

/**
 * List Runs
 */
export const listEvalRunsOptions = (options?: Options<ListEvalRunsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listEvalRuns({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listEvalRunsQueryKey(options),
  });
};

export const listEvalRunsInfiniteQueryKey = (
  options?: Options<ListEvalRunsData>,
): QueryKey<Options<ListEvalRunsData>> =>
  createQueryKey('listEvalRuns', options, true);

/**
 * List Runs
 */
export const listEvalRunsInfiniteOptions = (
  options?: Options<ListEvalRunsData>,
) => {
  return infiniteQueryOptions<
    ListEvalRunsResponse,
    AxiosError<ListEvalRunsError>,
    InfiniteData<ListEvalRunsResponse>,
    QueryKey<Options<ListEvalRunsData>>,
    | number
    | Pick<
        QueryKey<Options<ListEvalRunsData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ListEvalRunsData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listEvalRuns({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: listEvalRunsInfiniteQueryKey(options),
    },
  );
};

/**
 * Evaluate All Runs
 *
 * Re-score every finished run, e.g. after a new judge version, so its alignment with your labels can be measured.
 */
export const evaluateAllEvalRunsMutation = (
  options?: Partial<Options<EvaluateAllEvalRunsData>>,
): UseMutationOptions<
  EvaluateAllEvalRunsResponse,
  AxiosError<EvaluateAllEvalRunsError>,
  Options<EvaluateAllEvalRunsData>
> => {
  const mutationOptions: UseMutationOptions<
    EvaluateAllEvalRunsResponse,
    AxiosError<EvaluateAllEvalRunsError>,
    Options<EvaluateAllEvalRunsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await evaluateAllEvalRuns({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Evaluate Run
 */
export const evaluateEvalRunMutation = (
  options?: Partial<Options<EvaluateEvalRunData>>,
): UseMutationOptions<
  EvaluateEvalRunResponse,
  AxiosError<EvaluateEvalRunError>,
  Options<EvaluateEvalRunData>
> => {
  const mutationOptions: UseMutationOptions<
    EvaluateEvalRunResponse,
    AxiosError<EvaluateEvalRunError>,
    Options<EvaluateEvalRunData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await evaluateEvalRun({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const listEvaluatorsQueryKey = (options?: Options<ListEvaluatorsData>) =>
  createQueryKey('listEvaluators', options);

/**
 * List Evaluators
 */
export const listEvaluatorsOptions = (
  options?: Options<ListEvaluatorsData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listEvaluators({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listEvaluatorsQueryKey(options),
  });
};

/**
 * Create Evaluator
 *
 * A new LLM judge (code checks are built in).
 */
export const createEvaluatorMutation = (
  options?: Partial<Options<CreateEvaluatorData>>,
): UseMutationOptions<
  CreateEvaluatorResponse,
  AxiosError<CreateEvaluatorError>,
  Options<CreateEvaluatorData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateEvaluatorResponse,
    AxiosError<CreateEvaluatorError>,
    Options<CreateEvaluatorData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createEvaluator({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getEvaluatorQueryKey = (options: Options<GetEvaluatorData>) =>
  createQueryKey('getEvaluator', options);

/**
 * Get Evaluator
 *
 * Versions, alignment with human labels per version, and the lines where judge and human disagree.
 */
export const getEvaluatorOptions = (options: Options<GetEvaluatorData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getEvaluator({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getEvaluatorQueryKey(options),
  });
};

/**
 * Update Evaluator
 *
 * A changed prompt, model or threshold creates a new version and makes it current.
 */
export const updateEvaluatorMutation = (
  options?: Partial<Options<UpdateEvaluatorData>>,
): UseMutationOptions<
  UpdateEvaluatorResponse,
  AxiosError<UpdateEvaluatorError>,
  Options<UpdateEvaluatorData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateEvaluatorResponse,
    AxiosError<UpdateEvaluatorError>,
    Options<UpdateEvaluatorData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateEvaluator({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Set Evaluator Version
 */
export const setEvaluatorVersionMutation = (
  options?: Partial<Options<SetEvaluatorVersionData>>,
): UseMutationOptions<
  SetEvaluatorVersionResponse,
  AxiosError<SetEvaluatorVersionError>,
  Options<SetEvaluatorVersionData>
> => {
  const mutationOptions: UseMutationOptions<
    SetEvaluatorVersionResponse,
    AxiosError<SetEvaluatorVersionError>,
    Options<SetEvaluatorVersionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await setEvaluatorVersion({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getEvalLabelingQueueQueryKey = (
  options?: Options<GetEvalLabelingQueueData>,
) => createQueryKey('getEvalLabelingQueue', options);

/**
 * Labeling Queue
 */
export const getEvalLabelingQueueOptions = (
  options?: Options<GetEvalLabelingQueueData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getEvalLabelingQueue({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getEvalLabelingQueueQueryKey(options),
  });
};

export const getEvalWatchTokenQueryKey = (
  options: Options<GetEvalWatchTokenData>,
) => createQueryKey('getEvalWatchToken', options);

/**
 * Watch Run
 *
 * A hidden, listen-only LiveKit token to watch a running session: both voices, transcript, screen, debug events.
 */
export const getEvalWatchTokenOptions = (
  options: Options<GetEvalWatchTokenData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getEvalWatchToken({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getEvalWatchTokenQueryKey(options),
  });
};

export const listEvalRunLinesQueryKey = (
  options: Options<ListEvalRunLinesData>,
) => createQueryKey('listEvalRunLines', options);

/**
 * Run Lines
 */
export const listEvalRunLinesOptions = (
  options: Options<ListEvalRunLinesData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listEvalRunLines({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listEvalRunLinesQueryKey(options),
  });
};

export const getEvalFixturePromptsQueryKey = (
  options: Options<GetEvalFixturePromptsData>,
) => createQueryKey('getEvalFixturePrompts', options);

/**
 * Fixture Prompts
 *
 * The prompts the fixture's latest run used, to start an experiment's prompt overrides from.
 */
export const getEvalFixturePromptsOptions = (
  options: Options<GetEvalFixturePromptsData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getEvalFixturePrompts({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getEvalFixturePromptsQueryKey(options),
  });
};

export const listEvalReplaysQueryKey = (
  options?: Options<ListEvalReplaysData>,
) => createQueryKey('listEvalReplays', options);

/**
 * List Replays
 */
export const listEvalReplaysOptions = (
  options?: Options<ListEvalReplaysData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listEvalReplays({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listEvalReplaysQueryKey(options),
  });
};

/**
 * Create Replay
 *
 * Regenerate the selected tutor lines under a variant (model / instructions); the runner judges both versions.
 */
export const createEvalReplayMutation = (
  options?: Partial<Options<CreateEvalReplayData>>,
): UseMutationOptions<
  CreateEvalReplayResponse,
  AxiosError<CreateEvalReplayError>,
  Options<CreateEvalReplayData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateEvalReplayResponse,
    AxiosError<CreateEvalReplayError>,
    Options<CreateEvalReplayData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createEvalReplay({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getEvalReplayQueryKey = (options: Options<GetEvalReplayData>) =>
  createQueryKey('getEvalReplay', options);

/**
 * Get Replay
 */
export const getEvalReplayOptions = (options: Options<GetEvalReplayData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getEvalReplay({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getEvalReplayQueryKey(options),
  });
};

export const getEvalLabelQueueQueryKey = (
  options?: Options<GetEvalLabelQueueData>,
) => createQueryKey('getEvalLabelQueue', options);

/**
 * Label Queue
 *
 * Your next unlabeled tutor lines with context, alternating judge-bad and judge-good, plus your agreement so far.
 */
export const getEvalLabelQueueOptions = (
  options?: Options<GetEvalLabelQueueData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getEvalLabelQueue({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getEvalLabelQueueQueryKey(options),
  });
};

/**
 * Admin Trigger Deletions
 *
 * Manually trigger deletion processing (admin only)
 */
export const triggerDeletionProcessingMutation = (
  options?: Partial<Options<TriggerDeletionProcessingData>>,
): UseMutationOptions<
  unknown,
  AxiosError<TriggerDeletionProcessingError>,
  Options<TriggerDeletionProcessingData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    AxiosError<TriggerDeletionProcessingError>,
    Options<TriggerDeletionProcessingData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await triggerDeletionProcessing({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Admin Trigger Exports
 *
 * Manually trigger export processing (admin only)
 */
export const triggerExportProcessingMutation = (
  options?: Partial<Options<TriggerExportProcessingData>>,
): UseMutationOptions<
  unknown,
  AxiosError<TriggerExportProcessingError>,
  Options<TriggerExportProcessingData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    AxiosError<TriggerExportProcessingError>,
    Options<TriggerExportProcessingData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await triggerExportProcessing({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Admin Trigger Retention
 *
 * Manually trigger retention policy enforcement (admin only)
 */
export const triggerRetentionCleanupMutation = (
  options?: Partial<Options<TriggerRetentionCleanupData>>,
): UseMutationOptions<
  unknown,
  AxiosError<TriggerRetentionCleanupError>,
  Options<TriggerRetentionCleanupData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    AxiosError<TriggerRetentionCleanupError>,
    Options<TriggerRetentionCleanupData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await triggerRetentionCleanup({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getGdprQueueStatusQueryKey = (
  options?: Options<GetGdprQueueStatusData>,
) => createQueryKey('getGdprQueueStatus', options);

/**
 * Admin Get Queue Status
 *
 * Get GDPR task queue status (admin only)
 */
export const getGdprQueueStatusOptions = (
  options?: Options<GetGdprQueueStatusData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getGdprQueueStatus({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getGdprQueueStatusQueryKey(options),
  });
};

export const getUserDataSummaryGdprDataSummaryGetQueryKey = (
  options?: Options<GetUserDataSummaryGdprDataSummaryGetData>,
) => createQueryKey('getUserDataSummaryGdprDataSummaryGet', options);

/**
 * Get User Data Summary
 *
 * Get summary of all data associated with current user
 */
export const getUserDataSummaryGdprDataSummaryGetOptions = (
  options?: Options<GetUserDataSummaryGdprDataSummaryGetData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getUserDataSummaryGdprDataSummaryGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getUserDataSummaryGdprDataSummaryGetQueryKey(options),
  });
};

export const getUserDataSummaryByEmailGdprDataSummaryEmailGetQueryKey = (
  options: Options<GetUserDataSummaryByEmailGdprDataSummaryEmailGetData>,
) =>
  createQueryKey('getUserDataSummaryByEmailGdprDataSummaryEmailGet', options);

/**
 * Get User Data Summary By Email
 *
 * Get summary of all data associated with an email (public endpoint)
 */
export const getUserDataSummaryByEmailGdprDataSummaryEmailGetOptions = (
  options: Options<GetUserDataSummaryByEmailGdprDataSummaryEmailGetData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getUserDataSummaryByEmailGdprDataSummaryEmailGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getUserDataSummaryByEmailGdprDataSummaryEmailGetQueryKey(options),
  });
};

/**
 * Request Data Export
 *
 * Request data export for current user
 */
export const requestDataExportGdprExportPostMutation = (
  options?: Partial<Options<RequestDataExportGdprExportPostData>>,
): UseMutationOptions<
  RequestDataExportGdprExportPostResponse,
  AxiosError<RequestDataExportGdprExportPostError>,
  Options<RequestDataExportGdprExportPostData>
> => {
  const mutationOptions: UseMutationOptions<
    RequestDataExportGdprExportPostResponse,
    AxiosError<RequestDataExportGdprExportPostError>,
    Options<RequestDataExportGdprExportPostData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await requestDataExportGdprExportPost({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Request Data Export Public
 *
 * Request data export (public endpoint)
 */
export const requestDataExportPublicGdprExportPublicPostMutation = (
  options?: Partial<Options<RequestDataExportPublicGdprExportPublicPostData>>,
): UseMutationOptions<
  RequestDataExportPublicGdprExportPublicPostResponse,
  AxiosError<RequestDataExportPublicGdprExportPublicPostError>,
  Options<RequestDataExportPublicGdprExportPublicPostData>
> => {
  const mutationOptions: UseMutationOptions<
    RequestDataExportPublicGdprExportPublicPostResponse,
    AxiosError<RequestDataExportPublicGdprExportPublicPostError>,
    Options<RequestDataExportPublicGdprExportPublicPostData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await requestDataExportPublicGdprExportPublicPost({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getExportStatusGdprExportExportIdStatusGetQueryKey = (
  options: Options<GetExportStatusGdprExportExportIdStatusGetData>,
) => createQueryKey('getExportStatusGdprExportExportIdStatusGet', options);

/**
 * Get Export Status
 *
 * Get status of data export
 */
export const getExportStatusGdprExportExportIdStatusGetOptions = (
  options: Options<GetExportStatusGdprExportExportIdStatusGetData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getExportStatusGdprExportExportIdStatusGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getExportStatusGdprExportExportIdStatusGetQueryKey(options),
  });
};

/**
 * Request Account Deletion
 *
 * Request account deletion for current user
 */
export const requestAccountDeletionGdprDeleteAccountPostMutation = (
  options?: Partial<Options<RequestAccountDeletionGdprDeleteAccountPostData>>,
): UseMutationOptions<
  RequestAccountDeletionGdprDeleteAccountPostResponse,
  AxiosError<RequestAccountDeletionGdprDeleteAccountPostError>,
  Options<RequestAccountDeletionGdprDeleteAccountPostData>
> => {
  const mutationOptions: UseMutationOptions<
    RequestAccountDeletionGdprDeleteAccountPostResponse,
    AxiosError<RequestAccountDeletionGdprDeleteAccountPostError>,
    Options<RequestAccountDeletionGdprDeleteAccountPostData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await requestAccountDeletionGdprDeleteAccountPost({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Request Account Deletion Public
 *
 * Request account deletion (public endpoint)
 */
export const requestAccountDeletionPublicGdprDeleteAccountPublicPostMutation = (
  options?: Partial<
    Options<RequestAccountDeletionPublicGdprDeleteAccountPublicPostData>
  >,
): UseMutationOptions<
  RequestAccountDeletionPublicGdprDeleteAccountPublicPostResponse,
  AxiosError<RequestAccountDeletionPublicGdprDeleteAccountPublicPostError>,
  Options<RequestAccountDeletionPublicGdprDeleteAccountPublicPostData>
> => {
  const mutationOptions: UseMutationOptions<
    RequestAccountDeletionPublicGdprDeleteAccountPublicPostResponse,
    AxiosError<RequestAccountDeletionPublicGdprDeleteAccountPublicPostError>,
    Options<RequestAccountDeletionPublicGdprDeleteAccountPublicPostData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } =
        await requestAccountDeletionPublicGdprDeleteAccountPublicPost({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
      return data;
    },
  };
  return mutationOptions;
};

export const getDeletionStatusGdprDeletionStatusJobIdGetQueryKey = (
  options: Options<GetDeletionStatusGdprDeletionStatusJobIdGetData>,
) => createQueryKey('getDeletionStatusGdprDeletionStatusJobIdGet', options);

/**
 * Get Deletion Status
 *
 * Get status of account deletion
 */
export const getDeletionStatusGdprDeletionStatusJobIdGetOptions = (
  options: Options<GetDeletionStatusGdprDeletionStatusJobIdGetData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getDeletionStatusGdprDeletionStatusJobIdGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getDeletionStatusGdprDeletionStatusJobIdGetQueryKey(options),
  });
};

export const getComplianceStatusGdprComplianceStatusGetQueryKey = (
  options?: Options<GetComplianceStatusGdprComplianceStatusGetData>,
) => createQueryKey('getComplianceStatusGdprComplianceStatusGet', options);

/**
 * Get Compliance Status
 *
 * Get GDPR compliance status for user's company
 */
export const getComplianceStatusGdprComplianceStatusGetOptions = (
  options?: Options<GetComplianceStatusGdprComplianceStatusGetData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getComplianceStatusGdprComplianceStatusGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getComplianceStatusGdprComplianceStatusGetQueryKey(options),
  });
};

export const getAuditLogsGdprAuditLogsGetQueryKey = (
  options?: Options<GetAuditLogsGdprAuditLogsGetData>,
) => createQueryKey('getAuditLogsGdprAuditLogsGet', options);

/**
 * Get Audit Logs
 *
 * Get GDPR audit logs for user's company
 */
export const getAuditLogsGdprAuditLogsGetOptions = (
  options?: Options<GetAuditLogsGdprAuditLogsGetData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getAuditLogsGdprAuditLogsGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getAuditLogsGdprAuditLogsGetQueryKey(options),
  });
};

export const listMembersMembersGetQueryKey = (
  options?: Options<ListMembersMembersGetData>,
) => createQueryKey('listMembersMembersGet', options);

/**
 * List Members
 */
export const listMembersMembersGetOptions = (
  options?: Options<ListMembersMembersGetData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listMembersMembersGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listMembersMembersGetQueryKey(options),
  });
};

/**
 * Invite Member
 */
export const inviteMemberMembersInvitePostMutation = (
  options?: Partial<Options<InviteMemberMembersInvitePostData>>,
): UseMutationOptions<
  InviteMemberMembersInvitePostResponse,
  AxiosError<InviteMemberMembersInvitePostError>,
  Options<InviteMemberMembersInvitePostData>
> => {
  const mutationOptions: UseMutationOptions<
    InviteMemberMembersInvitePostResponse,
    AxiosError<InviteMemberMembersInvitePostError>,
    Options<InviteMemberMembersInvitePostData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await inviteMemberMembersInvitePost({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Revoke Invitation
 */
export const revokeInvitationMembersRevokePostMutation = (
  options?: Partial<Options<RevokeInvitationMembersRevokePostData>>,
): UseMutationOptions<
  unknown,
  AxiosError<RevokeInvitationMembersRevokePostError>,
  Options<RevokeInvitationMembersRevokePostData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    AxiosError<RevokeInvitationMembersRevokePostError>,
    Options<RevokeInvitationMembersRevokePostData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await revokeInvitationMembersRevokePost({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Update Role
 */
export const updateRoleMembersRolePostMutation = (
  options?: Partial<Options<UpdateRoleMembersRolePostData>>,
): UseMutationOptions<
  unknown,
  AxiosError<UpdateRoleMembersRolePostError>,
  Options<UpdateRoleMembersRolePostData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    AxiosError<UpdateRoleMembersRolePostError>,
    Options<UpdateRoleMembersRolePostData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateRoleMembersRolePost({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete Member
 */
export const deleteMemberMembersUserIdDeleteMutation = (
  options?: Partial<Options<DeleteMemberMembersUserIdDeleteData>>,
): UseMutationOptions<
  unknown,
  AxiosError<DeleteMemberMembersUserIdDeleteError>,
  Options<DeleteMemberMembersUserIdDeleteData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    AxiosError<DeleteMemberMembersUserIdDeleteError>,
    Options<DeleteMemberMembersUserIdDeleteData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteMemberMembersUserIdDelete({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getLeadsQueryKey = (options?: Options<GetLeadsData>) =>
  createQueryKey('getLeads', options);

/**
 * Get Leads
 */
export const getLeadsOptions = (options?: Options<GetLeadsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getLeads({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getLeadsQueryKey(options),
  });
};

export const getLeadsInfiniteQueryKey = (
  options?: Options<GetLeadsData>,
): QueryKey<Options<GetLeadsData>> => createQueryKey('getLeads', options, true);

/**
 * Get Leads
 */
export const getLeadsInfiniteOptions = (options?: Options<GetLeadsData>) => {
  return infiniteQueryOptions<
    GetLeadsResponse,
    AxiosError<GetLeadsError>,
    InfiniteData<GetLeadsResponse>,
    QueryKey<Options<GetLeadsData>>,
    | number
    | Pick<
        QueryKey<Options<GetLeadsData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetLeadsData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getLeads({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getLeadsInfiniteQueryKey(options),
    },
  );
};

export const getLeadSessionsQueryKey = (
  options: Options<GetLeadSessionsData>,
) => createQueryKey('getLeadSessions', options);

/**
 * Get Lead Sessions
 */
export const getLeadSessionsOptions = (
  options: Options<GetLeadSessionsData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getLeadSessions({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getLeadSessionsQueryKey(options),
  });
};

export const getLeadSessionRoomsQueryKey = (
  options: Options<GetLeadSessionRoomsData>,
) => createQueryKey('getLeadSessionRooms', options);

/**
 * Get Lead Session Rooms
 */
export const getLeadSessionRoomsOptions = (
  options: Options<GetLeadSessionRoomsData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getLeadSessionRooms({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getLeadSessionRoomsQueryKey(options),
  });
};

/**
 * Upsert Watch
 */
export const practiceUpsertWatchMutation = (
  options?: Partial<Options<PracticeUpsertWatchData>>,
): UseMutationOptions<
  PracticeUpsertWatchResponse,
  AxiosError<PracticeUpsertWatchError>,
  Options<PracticeUpsertWatchData>
> => {
  const mutationOptions: UseMutationOptions<
    PracticeUpsertWatchResponse,
    AxiosError<PracticeUpsertWatchError>,
    Options<PracticeUpsertWatchData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await practiceUpsertWatch({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const practiceGetHistoryQueryKey = (
  options?: Options<PracticeGetHistoryData>,
) => createQueryKey('practiceGetHistory', options);

/**
 * Get History
 */
export const practiceGetHistoryOptions = (
  options?: Options<PracticeGetHistoryData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await practiceGetHistory({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: practiceGetHistoryQueryKey(options),
  });
};

export const practiceGetTranscriptQueryKey = (
  options: Options<PracticeGetTranscriptData>,
) => createQueryKey('practiceGetTranscript', options);

/**
 * Get Transcript
 */
export const practiceGetTranscriptOptions = (
  options: Options<PracticeGetTranscriptData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await practiceGetTranscript({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: practiceGetTranscriptQueryKey(options),
  });
};

/**
 * Ensure Course
 */
export const practiceEnsureCourseMutation = (
  options?: Partial<Options<PracticeEnsureCourseData>>,
): UseMutationOptions<
  PracticeEnsureCourseResponse,
  AxiosError<PracticeEnsureCourseError>,
  Options<PracticeEnsureCourseData>
> => {
  const mutationOptions: UseMutationOptions<
    PracticeEnsureCourseResponse,
    AxiosError<PracticeEnsureCourseError>,
    Options<PracticeEnsureCourseData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await practiceEnsureCourse({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const practiceGetCourseQueryKey = (
  options: Options<PracticeGetCourseData>,
) => createQueryKey('practiceGetCourse', options);

/**
 * Get Course
 */
export const practiceGetCourseOptions = (
  options: Options<PracticeGetCourseData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await practiceGetCourse({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: practiceGetCourseQueryKey(options),
  });
};

/**
 * Synthesize Word
 */
export const practiceSynthesizeWordMutation = (
  options?: Partial<Options<PracticeSynthesizeWordData>>,
): UseMutationOptions<
  PracticeSynthesizeWordResponse,
  AxiosError<PracticeSynthesizeWordError>,
  Options<PracticeSynthesizeWordData>
> => {
  const mutationOptions: UseMutationOptions<
    PracticeSynthesizeWordResponse,
    AxiosError<PracticeSynthesizeWordError>,
    Options<PracticeSynthesizeWordData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await practiceSynthesizeWord({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Gloss Line
 */
export const practiceGlossLineMutation = (
  options?: Partial<Options<PracticeGlossLineData>>,
): UseMutationOptions<
  PracticeGlossLineResponse,
  AxiosError<PracticeGlossLineError>,
  Options<PracticeGlossLineData>
> => {
  const mutationOptions: UseMutationOptions<
    PracticeGlossLineResponse,
    AxiosError<PracticeGlossLineError>,
    Options<PracticeGlossLineData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await practiceGlossLine({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Translate Line
 */
export const practiceTranslateLineMutation = (
  options?: Partial<Options<PracticeTranslateLineData>>,
): UseMutationOptions<
  PracticeTranslateLineResponse2,
  AxiosError<PracticeTranslateLineError>,
  Options<PracticeTranslateLineData>
> => {
  const mutationOptions: UseMutationOptions<
    PracticeTranslateLineResponse2,
    AxiosError<PracticeTranslateLineError>,
    Options<PracticeTranslateLineData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await practiceTranslateLine({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Translate Lines
 *
 * Batch translate for overlay prefetch (cache hits skip Cloud Translation).
 */
export const practiceTranslateLinesMutation = (
  options?: Partial<Options<PracticeTranslateLinesData>>,
): UseMutationOptions<
  PracticeTranslateLinesResponse2,
  AxiosError<PracticeTranslateLinesError>,
  Options<PracticeTranslateLinesData>
> => {
  const mutationOptions: UseMutationOptions<
    PracticeTranslateLinesResponse2,
    AxiosError<PracticeTranslateLinesError>,
    Options<PracticeTranslateLinesData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await practiceTranslateLines({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Explain Line
 *
 * Stream a markdown grammar/vocabulary explanation of one subtitle line.
 *
 * The conversation lives entirely on the client: it sends the full transcript
 * each turn and we store nothing.
 */
export const practiceExplainLineMutation = (
  options?: Partial<Options<PracticeExplainLineData>>,
): UseMutationOptions<
  unknown,
  AxiosError<PracticeExplainLineError>,
  Options<PracticeExplainLineData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    AxiosError<PracticeExplainLineError>,
    Options<PracticeExplainLineData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await practiceExplainLine({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Speak Check
 *
 * Upload a Speak recording; Deepgram transcribes and we score accuracy.
 */
export const practiceSpeakCheckMutation = (
  options?: Partial<Options<PracticeSpeakCheckData>>,
): UseMutationOptions<
  PracticeSpeakCheckResponse2,
  AxiosError<PracticeSpeakCheckError>,
  Options<PracticeSpeakCheckData>
> => {
  const mutationOptions: UseMutationOptions<
    PracticeSpeakCheckResponse2,
    AxiosError<PracticeSpeakCheckError>,
    Options<PracticeSpeakCheckData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await practiceSpeakCheck({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Record Word Events
 *
 * Lines the viewer saw and words they looked up or heard, batched by the extension.
 */
export const practiceRecordWordEventsMutation = (
  options?: Partial<Options<PracticeRecordWordEventsData>>,
): UseMutationOptions<
  PracticeRecordWordEventsResponse,
  AxiosError<PracticeRecordWordEventsError>,
  Options<PracticeRecordWordEventsData>
> => {
  const mutationOptions: UseMutationOptions<
    PracticeRecordWordEventsResponse,
    AxiosError<PracticeRecordWordEventsError>,
    Options<PracticeRecordWordEventsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await practiceRecordWordEvents({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Set Word Status
 */
export const practiceSetWordStatusMutation = (
  options?: Partial<Options<PracticeSetWordStatusData>>,
): UseMutationOptions<
  PracticeSetWordStatusResponse,
  AxiosError<PracticeSetWordStatusError>,
  Options<PracticeSetWordStatusData>
> => {
  const mutationOptions: UseMutationOptions<
    PracticeSetWordStatusResponse,
    AxiosError<PracticeSetWordStatusError>,
    Options<PracticeSetWordStatusData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await practiceSetWordStatus({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const practiceListWordsQueryKey = (
  options: Options<PracticeListWordsData>,
) => createQueryKey('practiceListWords', options);

/**
 * List Words
 */
export const practiceListWordsOptions = (
  options: Options<PracticeListWordsData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await practiceListWords({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: practiceListWordsQueryKey(options),
  });
};

export const practiceListWordsInfiniteQueryKey = (
  options: Options<PracticeListWordsData>,
): QueryKey<Options<PracticeListWordsData>> =>
  createQueryKey('practiceListWords', options, true);

/**
 * List Words
 */
export const practiceListWordsInfiniteOptions = (
  options: Options<PracticeListWordsData>,
) => {
  return infiniteQueryOptions<
    PracticeListWordsResponse,
    AxiosError<PracticeListWordsError>,
    InfiniteData<PracticeListWordsResponse>,
    QueryKey<Options<PracticeListWordsData>>,
    | number
    | Pick<
        QueryKey<Options<PracticeListWordsData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<PracticeListWordsData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await practiceListWords({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: practiceListWordsInfiniteQueryKey(options),
    },
  );
};

export const practiceGetWordStatusesQueryKey = (
  options: Options<PracticeGetWordStatusesData>,
) => createQueryKey('practiceGetWordStatuses', options);

/**
 * Word Statuses
 */
export const practiceGetWordStatusesOptions = (
  options: Options<PracticeGetWordStatusesData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await practiceGetWordStatuses({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: practiceGetWordStatusesQueryKey(options),
  });
};

/**
 * Listen Beat
 *
 * Playback heartbeat; listening time is credited from the server clock.
 */
export const practiceListenBeatMutation = (
  options?: Partial<Options<PracticeListenBeatData>>,
): UseMutationOptions<
  PracticeListenBeatResponse2,
  AxiosError<PracticeListenBeatError>,
  Options<PracticeListenBeatData>
> => {
  const mutationOptions: UseMutationOptions<
    PracticeListenBeatResponse2,
    AxiosError<PracticeListenBeatError>,
    Options<PracticeListenBeatData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await practiceListenBeat({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const practiceGetStatsQueryKey = (
  options: Options<PracticeGetStatsData>,
) => createQueryKey('practiceGetStats', options);

/**
 * Get Stats
 */
export const practiceGetStatsOptions = (
  options: Options<PracticeGetStatsData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await practiceGetStats({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: practiceGetStatsQueryKey(options),
  });
};

export const practiceGetReviewQueryKey = (
  options: Options<PracticeGetReviewData>,
) => createQueryKey('practiceGetReview', options);

/**
 * Get Review
 */
export const practiceGetReviewOptions = (
  options: Options<PracticeGetReviewData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await practiceGetReview({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: practiceGetReviewQueryKey(options),
  });
};

export const practiceGetLeaderboardQueryKey = (
  options?: Options<PracticeGetLeaderboardData>,
) => createQueryKey('practiceGetLeaderboard', options);

/**
 * Get Leaderboard
 */
export const practiceGetLeaderboardOptions = (
  options?: Options<PracticeGetLeaderboardData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await practiceGetLeaderboard({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: practiceGetLeaderboardQueryKey(options),
  });
};

export const practiceStreamWordAudioQueryKey = (
  options: Options<PracticeStreamWordAudioData>,
) => createQueryKey('practiceStreamWordAudio', options);

/**
 * Stream Word Audio
 *
 * Stream cached MP3 so the extension does not need direct GCS access.
 */
export const practiceStreamWordAudioOptions = (
  options: Options<PracticeStreamWordAudioData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await practiceStreamWordAudio({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: practiceStreamWordAudioQueryKey(options),
  });
};

export const checkProvidersHealthHealthProvidersGetQueryKey = (
  options?: Options<CheckProvidersHealthHealthProvidersGetData>,
) => createQueryKey('checkProvidersHealthHealthProvidersGet', options);

/**
 * Check Providers Health
 */
export const checkProvidersHealthHealthProvidersGetOptions = (
  options?: Options<CheckProvidersHealthHealthProvidersGetData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await checkProvidersHealthHealthProvidersGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: checkProvidersHealthHealthProvidersGetQueryKey(options),
  });
};

export const listDemoVideosQueryKey = (options: Options<ListDemoVideosData>) =>
  createQueryKey('listDemoVideos', options);

/**
 * List Demo Videos
 */
export const listDemoVideosOptions = (options: Options<ListDemoVideosData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listDemoVideos({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listDemoVideosQueryKey(options),
  });
};

/**
 * Create Demo Video
 *
 * Start generating a 30-second demo script with voiceover for a session.
 */
export const createDemoVideoMutation = (
  options?: Partial<Options<CreateDemoVideoData>>,
): UseMutationOptions<
  CreateDemoVideoResponse,
  AxiosError<CreateDemoVideoError>,
  Options<CreateDemoVideoData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateDemoVideoResponse,
    AxiosError<CreateDemoVideoError>,
    Options<CreateDemoVideoData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createDemoVideo({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getDemoVideoQueryKey = (options: Options<GetDemoVideoData>) =>
  createQueryKey('getDemoVideo', options);

/**
 * Get Demo Video
 */
export const getDemoVideoOptions = (options: Options<GetDemoVideoData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getDemoVideo({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getDemoVideoQueryKey(options),
  });
};

export const getMcpAuthRequestQueryKey = (
  options: Options<GetMcpAuthRequestData>,
) => createQueryKey('getMcpAuthRequest', options);

/**
 * Get Auth Request
 */
export const getMcpAuthRequestOptions = (
  options: Options<GetMcpAuthRequestData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getMcpAuthRequest({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getMcpAuthRequestQueryKey(options),
  });
};

/**
 * Approve Auth Request
 */
export const approveMcpAuthRequestMutation = (
  options?: Partial<Options<ApproveMcpAuthRequestData>>,
): UseMutationOptions<
  ApproveMcpAuthRequestResponse,
  AxiosError<ApproveMcpAuthRequestError>,
  Options<ApproveMcpAuthRequestData>
> => {
  const mutationOptions: UseMutationOptions<
    ApproveMcpAuthRequestResponse,
    AxiosError<ApproveMcpAuthRequestError>,
    Options<ApproveMcpAuthRequestData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await approveMcpAuthRequest({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Deny Auth Request
 */
export const denyMcpAuthRequestMutation = (
  options?: Partial<Options<DenyMcpAuthRequestData>>,
): UseMutationOptions<
  DenyMcpAuthRequestResponse,
  AxiosError<DenyMcpAuthRequestError>,
  Options<DenyMcpAuthRequestData>
> => {
  const mutationOptions: UseMutationOptions<
    DenyMcpAuthRequestResponse,
    AxiosError<DenyMcpAuthRequestError>,
    Options<DenyMcpAuthRequestData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await denyMcpAuthRequest({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const listMcpConnectionsQueryKey = (
  options?: Options<ListMcpConnectionsData>,
) => createQueryKey('listMcpConnections', options);

/**
 * List Connections
 */
export const listMcpConnectionsOptions = (
  options?: Options<ListMcpConnectionsData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listMcpConnections({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listMcpConnectionsQueryKey(options),
  });
};

/**
 * Revoke Connection
 */
export const revokeMcpConnectionMutation = (
  options?: Partial<Options<RevokeMcpConnectionData>>,
): UseMutationOptions<
  unknown,
  AxiosError<RevokeMcpConnectionError>,
  Options<RevokeMcpConnectionData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    AxiosError<RevokeMcpConnectionError>,
    Options<RevokeMcpConnectionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await revokeMcpConnection({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};
